import type { Translations } from "../index";

export const ja: Translations = {
  lang: {
    en: "EN",
    ja: "日本語",
    "zh-HK": "繁中",
    "zh-TW": "繁中",
    "zh-CN": "简中",
    ko: "한국어",
    th: "ไทย",
    ru: "RU",
    current: "日本語",
  },

  nav: {
    platform: "プラットフォーム",
    forDesigners: "デザイナーの方へ",
    forBrands: "ブランドの方へ",
    forManufacturers: "プロダクション",
    forStudio: "Studio",
    caraAi: "Cara AI",
    pricing: "プラン・料金",
    more: "その他",
    about: "Caratzonについて",
    academy: "アカデミー",
    accessPlatform: "プラットフォームへ →",
    subline: "デザインとプロダクションが出会う場所",
    sublineBrand: "調達 · 製造 · 発売",
    sublineDesigner: "ジュエリーデザイナーのランウェイ",
    inspire: "Inspire",
    newsroom: "ニュースルーム",
    contact: "お問い合わせ",
    catalog: "カタログ",
    showcase: "ショーケース",
    switchToDesigners: "デザイナーの方へ →",
    switchToBrands: "ブランドの方へ →",
    howItWorks: "仕組み",
    overview: "概要",
  },

  footer: {
    subline: "デザイナーズジュエリー · B2Bソーシング · EPHマニュファクチャリング",
    tagline: "\"比類なきデザインと\n完璧なプロダクションが出会う場所。\"",
    accessPlatform: "プラットフォームへ →",
    ephCertified: "EPH認定マニュファクチャリング",
    copyright: "Caratzon Ltd. All rights reserved.",
    columns: {
      platform: "プラットフォーム",
      company: "企業情報",
      resources: "リソース",
      contact: "お問い合わせ",
    },
    links: {
      forDesigners: "デザイナーの方へ",
      forBrands: "ブランドの方へ",
      forManufacturers: "プロダクション",
      caraAi: "Cara AI",
      tradeCatalogue: "トレードカタログ",
      accessPlatform: "プラットフォームへ",
      aboutCaratzon: "Caratzonについて",
      ourStory: "ストーリー",
      leadership: "経営陣",
      pressMedia: "プレス・メディア",
      investorRelations: "IR情報",
      howItWorks: "ご利用の流れ",
      ephHub: "EPHマニュファクチャリングハブ",
      sustainabilityReport: "サステナビリティレポート",
      cadStandards: "CAD規格",
      supplierCode: "サプライヤー行動規範",
      academy: "アカデミー",
      inspire: "Inspire",
      newsroom: "ニュースルーム",
      aiCredits: "AIクレジット",
      contactUs: "お問い合わせ",
      becomeManufacturer: "製造パートナーになる",
    },
    offices: {
      hongkong: "デザインゲートウェイ · 香港",
      guangdong: "マニュファクチャリングハブ · 广东",
      london: "ヨーロッパトレードデスク",
    },
    legal: {
      terms: "利用規約",
      privacy: "プライバシーポリシー",
      cookies: "Cookieポリシー",
      supplierCode: "サプライヤー規範",
    },
  },

  home: {
    meta: {
      title: "Caratzon — B2Bジュエリーソーシング · プリエンジニアドCAD · AIマーケティング",
      description:
        "独立系ファインジュエリーのプレミアB2Bソーシングプラットフォーム。プリエンジニアドCADデザインをライセンスし、EPHでサステナブルに製造、Caratzon Studioでマーケティングアセットを即時生成。3段階のIPライセンス体系、エンドツーエンドの生産管理。",
    },
    emergence: {
      tagline: "スケッチから店頭まで。デザイン、ライセンス、製造——Caratzonだけ。",
      subtitle: "ジュエリーデザイン・ライセンス・製造のB2Bプラットフォーム",
      cta: "カタログを見る",
      ctaSecondary: "仕組みを見る",
    },
    process: {
      overline: "仕組み",
      steps: [
        { number: "01", heading: "発見", body: "世界中の独立デザイナーによるプレエンジニアリング作品を閲覧。", hook: "R&Dコスト不要。NRE費用不要。" },
        { number: "02", heading: "ライセンス", body: "IPティアを選び、数秒で商業権を取得。", hook: "すべてのライセンスにマーケティング素材付き。" },
        { number: "03", heading: "製造", body: "デザインはEPHのサステナブル製造ハブへ直送。完了。", hook: "工場管理ゼロ。完全トレーサビリティ。" },
      ],
    },
    storyBeat: {
      line1: "スケッチから店頭へ。",
      line2: "デザイン、ライセンス、製造。",
      line3: "Caratzon だけ。",
      splitLabel: "私は",
      splitDesigner: "デザイナー",
      splitBrand: "ブランドバイヤー",
    },
    showcase: {
      pieces: [
        {
          sku: "FD001-251225032",
          designer: "ヤーユースタジオ",
          name: "天幕ドレープネックレス",
          descriptor: "流れる金、光のなかに浮かぶ。",
        },
        {
          sku: "FD016-251224017",
          designer: "ゴールデンフールー",
          name: "福禄瓢箪ペンダント",
          descriptor: "古代のシンボル、現代のシルエット。",
        },
        {
          sku: "FD033-251225049",
          designer: "ピオニーアトリエ",
          name: "ブルームドロップイヤリング",
          descriptor: "花びら、落ちる途中で止まる。",
        },
        {
          sku: "FD051-251226013",
          designer: "ジェイドリバーデザイン",
          name: "リップルカフブレスレット",
          descriptor: "手首の水紋、金に凍る。",
        },
      ],
    },
    stats: [
      { value: "48+", numericValue: 48, label: "オリジナルデザイン" },
      { value: "12", numericValue: 12, label: "独立デザイナー" },
      { value: "6", numericValue: 6, label: "カ国" },
      { value: "80%", numericValue: 80, label: "デザイナー収益シェア", suffix: "%" },
    ],
    fork: {
      heading: "さあ、あなたはどちらの世界？",
      designer: {
        eyebrow: "デザイナーの方へ",
        line: "あなたの技術は世界の舞台にふさわしい——Instagramの投稿ではなく。",
        cta: "デザイナーとして入る",
      },
      brand: {
        eyebrow: "ブランドの方へ",
        line: "R&Dをスキップ。マーケティング素材付きでライセンス。今日から販売開始。",
        cta: "ブランドとして入る",
      },
    },
    close: {
      line: "次の章は、ここから始まる。",
      cta: "始める",
    },
    hero: {
      overline: "B2Bソーシングプラットフォーム · EPHによるサステナブルプロダクション",
      h1Line1: "デザインをソーシング。",
      h1Line2: "R&Dをスキップ。",
      h1Line3: "即日ローンチ。",
      tagline:
        "独立系ファインジュエリーのプレミアB2Bソーシングプラットフォーム。プリエンジニアドCADデザインをライセンスし、EPHハブでサステナブルに製造。AI Studioが「購入」クリックの瞬間にマーケティングアセットを自動生成します。",
      cta: "トレードカタログを見る",
      ctaSecondary: "Caratzon Studioについて",
    },
    pillars: {
      overline: "プラットフォームの強み",
      subtitle: "エンドツーエンドのワークフロー",
      items: [
        {
          heading: "AIマーケティングエンジン（Caratzon Studio）",
          body: "サンプル撮影のために数週間待つ必要はありません。すべてのライセンスにEssentials Kit（ECサイト用撮影・スペック・SEOコピー）が標準付属。Caratzon Kitにアップグレードで、ライフスタイルフォトグラフィー・SNSアセット・ブランドカラーに合わせたPDFラインシートを自動生成。",
        },
        {
          heading: "3段階のIPライセンス、法的に文書化",
          body: "スタンダード（非独占）、シーズナルエンバーゴ（12ヶ月独占）、またはフルVault IP（恒久的IP譲渡）。法的拘束力のある商用権 — 単なる握手ではありません。",
        },
        {
          heading: "エンドツーエンドEPHプロダクション",
          body: "オーダーは検証済みEPH製造ネットワークへダイレクトルーティング。キャスティング・セッティング・QC・物流を1つの統合型サステナブルハブで管理。ファクトリーネゴシエーション不要。",
        },
      ],
    },
    quote: {
      text: "\"他にはない意匠をソーシング。\n在庫到着前にマーケティングを開始。\"",
      attribution: "Caratzonの信条",
    },
    marquee: {
      ariaLabel: "カタログプレビュー",
    },
    howItWorks: {
      overline: "ご利用の流れ",
      subtitle: "3つのステップ",
      items: [
        {
          heading: "ディスカバー",
          body: "独立系クリエイターのプリエンジニアドオリジナルをブラウズ。各ピースのEssentials Kitをプレビュー — カタログ撮影・スペック・エディトリアルストーリー・インタラクティブ3Dビューア — コミット前にフルパッケージをご評価いただけます。",
        },
        {
          heading: "ライセンス＆ジェネレート",
          body: "IPティア（スタンダード・エンバーゴ・Vault）を選択し、数秒で商用権を取得。ライセンスがクリアした瞬間、Caratzon Studioがコンプリートマーケティングキットを生成。セールスチームが即座にアクションを開始できます。",
        },
        {
          heading: "EPHでプロデュース",
          body: "承認されたデザインはEPHの統合型ファシリティへルーティング。サステナブルエレクトロプレーティング、認定エコプロセス、エンドツーエンドのマイルストーントラッキング — マーケティングアセットはすでにライブ。",
        },
      ],
    },
    eph: {
      overline: "マニュファクチャリングパートナー",
      location: "中国",
      headline: "中国最大のサステナブル統合型ジュエリー＆エコプレーティング製造ハブ",
      body: "Caratzon経由のすべての生産オーダーは、EPHの統合型ファシリティで履行されます。鋳造・石留め・研磨・エコプレーティングをワンルーフで、完全な環境コンプライアンスとマイルストーンのトレーサビリティを実現。",
      attrs: [
        {
          label: "サステナブルエレクトロプレーティング",
          body: "低排出エコプレーティングライン — ゴールド・ロジウム・合金フィニッシュ。化学廃棄物の削減とクローズドループ水処理システムを検証済み。",
        },
        {
          label: "統合型ファシリティ",
          body: "鋳造・石留め・研磨・プレーティングをワンルーフで。ハンドオフの削減、厳格な公差管理、短縮されたサイクルタイム。",
        },
        {
          label: "ダイレクトインテグレーション",
          body: "Caratzonで承認されたデザインは、EPHの生産キューへ自動ルーティング。手動の再ソーシングや断絶したサプライチェーンは発生しません。",
        },
        {
          label: "フルトレーサビリティ",
          body: "すべての生産フェーズがログされ、Caratzonダッシュボードで可視化 — 原材料受領から最終QCサインオフまで。",
        },
      ],
    },
    forWhom: {
      overline: "こんな方に",
      heading: "トレードバイヤーの\nために構築。",
      items: [
        {
          title: "ジュエリーリテーラー",
          desc: "競合が入手できないデザイナーダイレクトの作品をソーシング。すべてのライセンスにEssentials Kit標準付属 — カタログ撮影・スペック・SEOコピーが即時レディ。Caratzon Kitにアップグレードでライフスタイルフォトグラフィー＆SNSアセットも。ライセンス取得と同日にWebサイト掲載・カタログ掲載・Instagram投稿が可能。",
        },
        {
          title: "ブティックオーナー",
          desc: "1デザインあたり$1,500以上のNRE（初期開発費）をスキップ。テスト済み・生産レディのオリジナルをライセンス。Caratzon Kitを生成し、ライセンス契約と同日にShopifyで新作を掲載。",
        },
        {
          title: "マルチブランドディストリビューター",
          desc: "1つのベンダープロファイルで数十のグローバル独立系デザイナーからソーシング。完璧にフォーマットされたPDFホールセールラインシートを自動生成し、リテールアカウントへ即時共有。",
        },
      ],
    },
    caraAI: {
      overline: "Cara AI · エンジニアリングインテリジェンス",
      heading: "工場のために\n設計するAI。",
      body: "Caraはファンタジーレンダリングを生成しません。ロストワックス鋳造、石留めに耐え、一日中手に着けていても快適なジュエリーをエンジニアリングします——コーヒーを飲み終わる前に完全な部品表まで生成します。",
      stats: [
        { value: "±0.15mm", label: "合金ごとの収縮補正" },
        { value: "0.6mm", label: "最小壁厚を強制" },
        { value: "4-Prong+", label: "ストーンリテンション設計" },
        { value: "R≥0.4mm", label: "終日快適なエッジ半径" },
      ],
      cta: "Cara AI を試す — ライブデモ",
      ctaSecondary: "詳しく見る",
    },
    inspirePreview: {
      overline: "Inspireで発見",
      heading: "スクロール。保存。ソーシング。",
      body: "Caratzon Inspireへようこそ — B2Bディスカバリーフィード。世界最高峰の3D CADデザインのキュレーションストリームをブラウズ。ブランドのムードボードを構築し、お気に入りの独立系クリエイターをフォロー。インスピレーションからプロダクションへワンクリックで移行。",
      cta: "Inspireを探索",
    },
    designerBanner: {
      overline: "デザイナー向け",
      heading: "あなたのCADファイルに\nふさわしいポートフォリオを。",
      body: "厳選されたグローバル3Dクリエイターネットワークに参加。プリエンジニアドデザインをアップロードすると、プレミアムなCaratzon Inspireポートフォリオが自動的にアンロック。AIが無料でレンダリングし、数千の認定リテールバイヤーに作品をショーケース。ハイマージンのロイヤリティを獲得できます。",
      cta: "デザイナーポートフォリオを申請",
    },
    footerCta: {
      overline: "ソーシングを始める",
      heading: "他にはない意匠を\nソーシング。",
      cta: "トレードカタログを見る",
      tradeOnly: "トレードアカウント限定",
    },
  },

  forDesigners: {
    meta: {
      title: "デザイナーの方へ · Caratzon",
      description:
        "あなたのストーリーをAIが紡ぎ、作品を世界へ届けます。Caratzon Inspireに参加 — CADをアップロードし、クラフトについていくつかの質問に答えるだけ。AIがデザイナーストーリーを執筆し、ライセンス料の80%と永続的ロイヤリティを獲得できます。",
    },
    hero: {
      overline: "独立系ジュエリーデザイナーの方へ",
      h1Line1: "あなたの物語を。",
      h1Line2: "美しく、世界へ。",
      tagline:
        "あなたのクラフト、インスピレーション、ビジョンについていくつかの質問にお答えください。AIがその回答を魅力的なデザイナーナラティブに変換し、世界中のバイヤーの目に届けます。",
      cta: "インスピレーションになる →",
    },
    stats: {
      share: "ライセンス料のデザイナー取り分",
      ipProtected: "IP完全保護",
      cadNote: "CADデータはバイヤーに開示されません",
      perpetual: "永続的ロイヤリティ",
      royaltiesNote: "製造ユニットごとに発生",
      zeroMarketing: "マーケティング負担ゼロ",
      portfolioNote: "AIがストーリーを構築",
    },
    pain: {
      overline: "現状の課題",
      p1: "あなたは才能あるジュエリーデザイナーです。作品はオリジナリティに溢れ、美しく仕上げられ、生産の準備が整っています。",
      p2: "しかし生計を立てるために、SNS運用、コピーライティング、ライフスタイル撮影、工場との折衝まで一人で担っていませんか。最高傑作がハードドライブに眠ったまま — グローバルB2Bブランドへ届ける時間も資金もない。それが現実です。",
      quote: "世界で最も才能あるジュエリーデザイナーが、最も得意なこと — デザイン — に集中できる世界を。それがCaratzonの存在意義です。",
      quoteAttribution: "— Caratzon創業チーム",
    },
    inspire: {
      overline: "インスピレーションになる",
      subtitle: "AIが紡ぐ、あなただけのストーリー。",
      heading: "7つの問い。\n唯一無二のストーリー。",
      p1: "オンボーディングでは、あなたの原点、哲学、インスピレーション、作品の背景にある感性についてお聞きします。フォーム入力ではなく、クリエイターとしてのあなた自身を語る対話です。",
      p2: "AIがその回答をもとに、マガジンクオリティのデザイナープロフィールを制作 — ヘッドライン、ナラティブ、テーマ別セクション、ブランドボイスキーワード。バイヤーがスクロールを止め、コンタクトを取りたくなるストーリーです。",
      previewLabel: "AI 生成プレビュー",
      previewTitle: "テンション — Ariaの世界",
      previewBody: "彼女は建築家が光を考えるようにジュエリーをデザインする——装飾のためではなく、明らかにするために。",
      previewExtended: "ボスポラス海峡を見下ろす日差しあふれるスタジオで、Aria Atelierは精密さと野性の交差点で制作している。彼女の作品はテクスチャのある紙の上の水彩スケッチから始まる——画面に触れる前に重さを感じる必要がある……",
      previewKeywords: ["テンション", "ゴールド", "建築的", "侘び寂び", "静かな自信", "ボスポラスの光"],
      cta: "インスピレーションになる →",
      features: [
        {
          label: "あなたの原点、あなたの声",
          description: "デザイナーになった経緯、惹かれる素材、美意識を形作る文化的背景。あなた自身の言葉が、公開ストーリーの礎となります。",
        },
        {
          label: "哲学とインナーワールド",
          description: "あなたのジュエリーを身につけた人に何を感じてほしいか。作品を定義するクリエイティブテンション。これらの深い問いが、テンプレートではない「あなたらしさ」をAIに与えます。",
        },
        {
          label: "Inspireで世界へ公開",
          description: "AI生成のストーリーはInspireクリエイターページで公開。バイヤー、プレス、コラボレーターが発見できるパブリックプロフィールです。Studioダッシュボードからいつでも編集可能。",
        },
      ],
    },
    designOfWeek: {
      overline: "Design of the Week",
      subtitle: "毎週選出。世界中で紹介。",
      heading: "Design of the Weekに\n選ばれる。",
      badgeLabel: "今週のデザイン",
      featuredTitle: "プリズマティック・ペタルズ・リング",
      featuredAttribution: "by Aria Atelier · 2026年3月3日フィーチャー",
      p1: "毎週、Caratzon編集チームが1つの優れたデザインを選出し、プラットフォーム全体でスポットライトを当てます。選出デザイナーはInspireホームページのプライムポジション、専用エディトリアル特集、バイヤーネットワーク全体へのダイレクトな露出を獲得します。",
      p2: "Design of the Weekは単なる露出ではありません — 業界屈指のキュレーターに認められたシグナルです。過去の選出からライセンス契約、プレス掲載、長期的なブランドパートナーシップへと発展しています。",
      benefits: [
        {
          label: "ホームページスポットライト",
          description: "7日間、Inspireホームページの最も目立つ位置にデザインとストーリーを掲載。バイヤーがプラットフォームを訪れた際に最初に目にする場所です。",
        },
        {
          label: "エディトリアル特集",
          description: "AI生成ストーリーをベースに制作される専用エディトリアル記事。デザインのインスピレーション、素材選定、製造アプローチに関する深いコンテキストを付加。",
        },
        {
          label: "バイヤーネットワークアラート",
          description: "プラットフォーム上のすべてのアクティブバイヤーに、あなたのデザインを特集したキュレーション通知を配信。ライセンス交渉へのダイレクトパイプライン。",
        },
      ],
    },
    platform: {
      overline: "プラットフォームの仕組み",
      subtitle: "手間ゼロ。リーチ最大化。",
      items: [
        {
          heading: "AIがストーリーを語る",
          body: "オンボーディングでクラフトについての質問に答えるだけ。AIがデザイナーナラティブを執筆し、ブランドボイスキーワードを生成し、Inspireクリエイターページを公開 — 作品とともに進化するライブポートフォリオです。",
        },
        {
          heading: "グローバルバイヤーへのダイレクトアクセス",
          body: "自動生成されたポートフォリオが、積極的にソーシングを行う大手リテールブランドのバイヤーや生産マネージャーの目に届きます。営業活動は不要 — キュレーションされたショーケースを通じて、バイヤーがあなたを見つけます。",
        },
        {
          heading: "製造の煩雑さゼロ",
          body: "ブランドがデザインをライセンスしても、工場とのやり取りは一切発生しません。プラットフォームがファイルを厳選された製造パートナーへセキュアにルーティング。鋳造・QC・物流はすべてCaratzonが対応します。",
        },
        {
          heading: "鉄壁のIP保護",
          body: "CADファイルはいかなるライセンスタイプでもバイヤーに開示されません。ブランドが取得するのは生産権のみ。ソースファイルはNDA下の厳選された製造パートナーにのみ提供されます。デザインが譲渡されるのは、完全IP取得の場合に限ります。",
        },
      ],
    },
    collections: {
      overline: "コレクション + AIストーリーテリング",
      subtitle: "あなたのデザインは、グリッド表示以上の価値がある。",
      heading: "作品をグルーピング。\nAIがストーリーを紡ぐ。",
      p1: "2つ以上の公開デザインを選択すると、AIが共通項 — 共有素材、ムード、クリエイティブセンシビリティ — を見出し、その軸で完全なプレゼンテーションを構築します。",
      p2: "ブランドは個々のピースだけでなく、一貫したクリエイティブビジョンとまとまりのある作品群を持つデザイナーとして認識します。それがコンタクトにつながる理由です。",
      features: [
        {
          label: "すべての作品に一貫したボイス",
          description: "AIがデザイン全体を貫くクリエイティブスレッド — 共有パレット、ムード、インスピレーション — を特定。バイヤーはランダムなファイル群ではなく、一貫したビジョンを目にします。",
        },
        {
          label: "作品が語る、ひとつの物語",
          description: "各デザインに名前を付け、それらの間のつながりを描く統一ナラティブ。バイヤーは問い合わせの前に、コレクションの背景にある思想を理解します。",
        },
        {
          label: "すべてのコレクションがVogueクオリティ",
          description: "統一されたエディトリアルテンプレートによるマガジンクオリティのショーケース — カバーイメージ、ピーススポットライト、すべてのコレクションに一貫したビジュアルフィール。",
        },
      ],
      cta: "Studioでコレクションを見る →",
    },
    badges: {
      premium: "プレミアム",
    },
    revenue: {
      overline: "3つの収益モデル",
      subtitle: "3つの方法で対価を得る",
      heading: "ブランドは3つの方法で取得。\nあなたは3つの方法で収益。",
      footnote:
        "3つのモデルすべてでライセンス料の80%を獲得。Caratzonの20%はプラットフォーム運営・マーケティング・製造コーディネーションに充当されます。スタンダードおよびシーズナルエンバーゴでは、製造ユニットごとに永続的ロイヤリティが発生 — 初回取引後もデザインが収益を生み続けます。完全独占権はクリーンな一括IP譲渡：継続ロイヤリティなし、あなたが設定した最低価格でのプレミアム一括払いのみ。",
      models: [
        {
          tier: "Standard",
          label: "非独占プロダクションライセンス",
          heading: "スタンダードライセンス",
          description:
            "ブランドはCaratzonの製造ネットワークを通じてデザインを生産する権利をライセンスします。非独占 — 複数ブランドが同時にスタンダードライセンスを保有可能。ライセンス料の80%と製造ユニットごとの永続ロイヤリティを獲得できます。",
          benefit: "80%があなたへ · 永続ロイヤリティ · デザインはマーケットに残る",
        },
        {
          tier: "Premium",
          label: "12ヶ月独占製造権",
          heading: "シーズナルエンバーゴ",
          description:
            "ブランドがプレミアムを支払い、12ヶ月間デザインをエンバーゴ。キャンペーン期間中、作品はマーケットプレイスから非表示となり、競合は生産不可。エンバーゴ料の80%と製造ユニットごとの永続ロイヤリティを獲得。期間終了後、デザインはオープンマーケットに復帰します。",
          benefit: "80%があなたへ · 高額前払い · 期間限定 · 繰り返し可能",
        },
        {
          tier: "Vault",
          label: "完全独占権（IP譲渡）",
          heading: "完全独占権",
          description:
            "ブランドが恒久的な所有権を取得し、生の生産ファイル（.STL / .3DM）を直接受領。デザインはマーケットプレイスから恒久的に削除されます。あなた自身が設定した一括プレミアムの80%を受け取ります。クリーンなエグジット：1回の支払い、デザイン引退、以降の義務なし。",
          benefit: "80%があなたへ · 最低価格はあなたが設定 · クリーンエグジット",
        },
      ],
    },
    steps: {
      overline: "オンボーディングから収益まで",
      subtitle: "3つのステップ",
      items: [
        {
          heading: "インスピレーションになる",
          body: "クラフト、哲学、インスピレーションについての質問に答えてください。AIがデザイナーナラティブを生成し、Inspireページを公開 — バイヤーが発見するパブリッククリエイタープロフィール。最初のCADをアップロードしてポートフォリオを完成させましょう。",
        },
        {
          heading: "AIがブランドを構築",
          body: "Story Labがスタジオクオリティのルックブック撮影と各作品のエディトリアルナラティブを生成。デザインをコレクションにグルーピングし、AIが統一ストーリーを執筆。Design of the Weekに選出されれば最大の露出を獲得。",
        },
        {
          heading: "収益を獲得",
          body: "ブランドがあなたの作品を発見し、ライセンスをリクエスト。承認またはカウンター。確認後、生産は自動ルーティング — 1グラムも鋳造される前にライセンス料の80%が確保され、製造ユニットごとにロイヤリティが発生します。",
        },
      ],
    },
    bottomLine: {
      overline: "結論",
      p1: "あなたの仕事はクリエイションに集中すること。AIがストーリーを語り、プラットフォームが作品を販売します。",
      p2: "最初のオンボーディングから最初のライセンス契約まで — ナラティブ、撮影、バイヤーディスカバリー、マニュファクチャリングはすべてCaratzonが担当。あなたはデザインに専念してください。",
      shareLabel: "あなたの取り分",
      shareNote:
        "ライセンス料の80%。スタンダードおよびシーズナルエンバーゴではユニットごとの永続ロイヤリティ。完全独占権ではあなたが価格を設定するクリーンな一括プレミアム。Caratzonの20%は、あなたが眠っている間も作品を販売し続けるマーケティングエンジンを支えています。",
    },
    cta: {
      overline: "インスピレーションになる",
      heading: "あなたの物語を。\nあなたのスポットライトで。",
      primary: "インスピレーションになる →",
      secondary: "すでにデザイナーの方はこちら → Studioを開く",
    },
  },

  forBrands: {
    meta: {
      title: "ブランドの方へ · Caratzon",
      description:
        "独立系クリエイターのオリジナルジュエリーデザインをソーシング。全ライセンスにEssentials Kit（カタログ撮影・スペック・SEOコピー）が標準付属。Caratzon Kitにアップグレードで、AI生成ライフスタイル撮影・ラインシート・SNSアセットも利用可能。ライセンス取得と同日に市場投入。",
    },
    howItWorks: {
      meta: {
        title: "仕組み — ブランド向け Caratzon",
        description: "ディスカバリーからお届けまで — デザイナーオリジナルを閲覧し、ライセンスティアを選択。製造ネットワークが生産を管理する間、マーケティングアセットは即時ライブに。",
      },
      headline: "ディスカバリーから\nお届けまで。",
      intro: "認証済みデザイナーオリジナルを閲覧。ライセンスを選択。製造ネットワークが生産を管理する間、マーケティングアセットは即時ライブに。仕組みの詳細をご覧ください。",
    },
    hero: {
      overline: "ジュエリーブランド · ブティック · ディストリビューターの方へ",
      h1Line1: "他にはない",
      h1Line2: "デザインを",
      h1Line3: "ソーシング。",
      tagline:
        "デザイナーダイレクトのファインジュエリー。全ライセンスにEssentials Kitが標準付属 — カタログ撮影・スペック・SEOコピーを即時提供。Caratzon Kitにアップグレードで、AI生成ライフスタイル撮影・ラインシート・SNSアセットも利用可能。数ヶ月ではなく、数日で市場投入。",
      ctaPrimary: "トレードカタログを見る",
      ctaSecondary: "仕組みを見る →",
    },
    marquee: {
      ariaLabel: "カタログプレビュー",
    },
    badges: {
      fullIp: "完全IP",
    },
    stats: {
      tiers: "ライセンスティア",
      designerDirect: "デザイナーダイレクト",
      noIntermediaries: "中間業者ゼロ",
      contentReady: "マーケティング標準付属",
      contentReadySub: "全ライセンスにEssentials Kit · Caratzon Kitアップグレード可能",
      productionManaged: "生産管理",
      endToEnd: "エンドツーエンド",
    },
    acquire: {
      overline: "ライセンスモデル",
      subtitle: "あなたのコレクション、あなたの条件で",
      heading: "Caratzonデザインを\n取得する3つの方法。",
      models: [
        {
          tier: "Standard",
          label: "アクティベーション＆アセットフィー",
          heading: "スタンダードライセンス",
          description:
            "単なる許諾ではありません — 料金の何倍もの価値を持つショートカットです。生産レディなデザインとEssentials Kit（カタログ撮影・SEO商品コピー・精密技術スペック）を取得。契約と同日にストアへ掲載可能です。Caratzon Kitにアップグレードで、ライフスタイル撮影・ラインシート・SNSアセットも利用可能。",
          gets: [
            "Essentials Kit標準付属 — カタログ撮影・SEO商品ストーリー・スペックが即日レディ",
            "Caratzon Kitアップグレード可能 — ライフスタイル撮影・ラインシート・SNSアセット",
            "即時製造アクセス — 生産パイプラインで即座にアンロック",
            "R&Dコストゼロ — 量産向けに検証済みのプリエンジニアドCAD",
            "商用権 — 自社ブランドでのホワイトラベル販売、無期限",
          ],
          benefit: "Essentials Kit付属 · R&Dスキップ · 即日ローンチ",
        },
        {
          tier: "Embargo",
          label: "12ヶ月独占製造権",
          heading: "シーズナルエンバーゴ",
          description:
            "次のキャンペーンに向けてデザインをロック。12ヶ月の独占製造権 — エンバーゴ期間中はマーケットプレイスから非表示。競合は生産不可。エンバーゴ解除後、デザインはマーケットに復帰します。",
          gets: [
            "独占ロック — 期間中、競合の生産はゼロ",
            "スタンダードライセンスの全特典を含む",
            "Essentials Kit付属 — 12ヶ月間あなた専用の独占カタログ撮影＆ストーリー。Caratzon Kitアップグレード可能",
            "エンバーゴ全期間、マーケットプレイスから非表示",
          ],
          benefit: "競合プロテクション · 独占コンテンツ · ヒーロープロダクトの可能性",
        },
        {
          tier: "Vault",
          label: "完全独占権（IP譲渡）",
          heading: "完全独占権",
          description:
            "IPを永久に所有。恒久的な所有権を取得 — デザインはマーケットプレイスから即時削除。支払い完了と同時に、生産レディの生ファイル（.STL / .3DM）を直接受領。他ブランドがこのデザインをソーシングすることは二度とありません。ソースファイルが譲渡される唯一のケースです。",
          gets: [
            "恒久的IP所有権 — デザインはマーケットプレイスから引退",
            "生の生産ファイル（.STL / .3DM）を直接譲渡",
            "Caratzon Kit付属 — エージェンシー不要。AIでブランド専用のライフスタイル撮影・ラインシート・ソーシャルキットを無制限に生成",
            "デザイナー設定の最低価格 — そこから交渉",
          ],
          benefit: "恒久的独占 · Caratzon Kit付属 · CADを手元に",
        },
      ],
      whyStandard: {
        label: "スタンダードライセンス料の意味とは？",
        heading: "許諾料ではありません。圧倒的なショートカットへの投資です。",
        points: [
          {
            heading: "NRE（初期開発費）をスキップ",
            body: "従来の製造では、1デザインあたり3Dモデリング・ワックスプリント・テスト鋳造・リビジョンで$500–$2,000以上が発生。スタンダードライセンスはこれらすべてを代替します — ファイルは設計・ストレステスト済みです。",
          },
          {
            heading: "Essentials Kit — 今日、ストアに掲載",
            body: "全スタンダードライセンスにEssentials Kitが付属：高解像度カタログ撮影・SEO最適化商品コピー・精密技術スペック — ライセンス取得の瞬間に生成。契約と同日にストアへ掲載可能。フルクリエイティブスイートが必要になったら、Caratzon KitにアップグレードでAI生成ライフスタイル撮影・ブランドラインシート・投稿レディのSNSアセットを利用できます。",
          },
          {
            heading: "ホワイトラベル、法的リスクゼロ",
            body: "自社ブランド名・自社パッケージで販売する完全な商用権を取得。デザイナーは著作権に関する不行使に同意。リスクなくビジネスを構築できます。",
          },
        ],
      },
      ipNotes: {
        standardLabel: "スタンダードライセンス & シーズナルエンバーゴ",
        standardBody:
          "生産ファイルはCaratzonが厳重に管理し、NDA下の検証済み製造パートナーにのみ提供。生のCADは受領できません — 生産は当社ネットワーク経由で自動ルーティングされます。",
        vaultLabel: "完全独占権",
        vaultBody:
          "支払い完了と同時に、デザイナーの生産レディ .STL / .3DM ファイルが直接譲渡されます。デザインはカタログから恒久的に引退 — 他ブランドがソーシングすることは二度とありません。",
      },
    },
    process: {
      overline: "ご利用の流れ",
      subtitle: "ディスカバリーからデリバリーまで",
      items: [
        {
          heading: "ディスカバー",
          body: "認証済みデザイナーオリジナルをブラウズ。各ピースのEssentials Kitをプレビュー — カタログ撮影・スペック・エディトリアルストーリー・インタラクティブ3Dビューア — コミット前にフルパッケージをご評価いただけます。",
        },
        {
          heading: "ライセンス",
          body: "ティアを選択。ソーシングリクエストを送信し、デザイナーと直接条件を交渉、ライセンスを確定。すべて文書化され、法的に構成されています。",
        },
        {
          heading: "プロデュース",
          body: "オーダーは製造ネットワークへ自動ルーティング — 鋳造・石留め・QC・物流をエンドツーエンドで管理。生産進行中も、Essentials Kitはすでにストアで公開済み。Caratzon Kitにアップグレードすれば、ライフスタイル撮影・ラインシート・SNSアセットも同時公開。在庫到着前にプロモーションを開始できます。",
        },
      ],
      quote: "\"オリジナルをソーシング。スケールで製造。\n工場との関係構築は不要。\"",
      bullets: [
        "アジア・ヨーロッパの検証済み製造ネットワーク",
        "鋳造・石留め・QC・物流をエンドツーエンドで管理",
        "全ライセンスにEssentials Kit標準付属 — カタログ撮影・スペック・SEOコピー",
        "Caratzon Kitアップグレード：AIライフスタイル撮影・ブランドラインシート・SNSアセットをオンデマンドで",
      ],
      teaserItems: [
        { heading: "ディスカバー", body: "フルプレビュー付きでデザイナーオリジナルを閲覧。" },
        { heading: "ライセンス", body: "ティアを選択し、商業権を確定。" },
        { heading: "プロデュース", body: "アセットがライブになる間、製造をエンドツーエンドで管理。" },
      ],
      teaserCta: "仕組みを見る →",
    },
    vs: {
      overline: "従来の卸売との比較",
      traditional: "従来型",
      caratzon: "Caratzon",
      rows: [
        ["出自", "不明確な出所、多層サプライチェーン", "認証済み独立系デザイナーからダイレクト"],
        ["R&D / NREコスト", "1デザインあたり$500–$2,000以上（3Dモデリング・ワックスプリント・テスト鋳造・リビジョン）", "ゼロ — 量産向けにプリエンジニアド＆検証済み"],
        ["市場投入スピード", "掲載までに数週間のエンジニアリング＋サンプリング", "今日ライセンス、今日ストア掲載 — Essentials Kit即時付属"],
        ["マーケティングアセット", "フォトグラファー・スタイリスト・コピーライターを手配 — 数週間、コレクションごとに数千ドル", "Essentials Kit即時付属。AI生成Caratzon Kit（ライフスタイル・SNS・ラインシート）をオンデマンドで"],
        ["商用権", "別途交渉、不明確なケースが多い", "ホワイトラベル権付属 — 自社ブランドで無期限販売"],
        ["独占性", "競合をブロックする仕組みなし", "スタンダード、シーズナルエンバーゴ（12ヶ月）、完全独占権（恒久）"],
        ["生産", "自社で工場リレーションを管理", "製造ネットワーク経由で自動ルーティング"],
      ],
    },
    studio: {
      overline: "Caratzon Studio",
      heading: "デザインをソーシング。\nマーケティングはAIが生成。",
      intro:
        "新しい在庫のソーシングは、撮影のためにサンプル到着を数週間待つことを意味していました。Caratzon Studioなら、ライセンス取得の瞬間にマーケティングアセットが生成されます。ローンチ戦略をお選びください：",
      essentials: {
        heading: "Essentials Kit",
        badge: "全ライセンスに標準付属",
        body: "データ入力は不要。デザインをライセンスした瞬間に、生産レディのスペック・鮮明なカタログ撮影・SEOコピーが即時生成。今日、ストアに新しい在庫を掲載するための完璧なベースラインです。",
        features: [
          "高解像度・白背景のECサイト用カットアウト",
          "SEO最適化された商品コピー",
          "精密な技術・素材スペック",
        ],
      },
      caratzonKit: {
        heading: "Caratzon Kit",
        badge: "プレミアムローンチアップグレード",
        body: "フォトシュート不要。ワンクリックでクリエイティブエージェンシーを丸ごと代替。ロゴ・ブランドカラー・美学をライフスタイル撮影・ラインシート・SNSキットにシームレスに統合。",
        features: [
          "AI生成ライフスタイル＆オンモデルフォトグラフィー",
          "ブランドスタイルに合わせた自動フォーマットPDFホールセールラインシート",
          "投稿レディのSNSアセット（Reels/TikTokクロップ＆キャプション）",
        ],
      },
    },
    caraAI: {
      overline: "Cara AI · エンジニアリングインテリジェンス",
      heading: "画像生成ツールではない。\nジュエリーエンジニアリングAI。",
      intro: "ほとんどのAIは綺麗な画像を生成するだけです。Caraは工場の現場で生き残り、手に着けて心地よいデザインを生成します。結果はムードボードではなく、完全な部品表が添付された生産可能な設計図です。",
      pillars: [
        {
          stat: "±0.15mm",
          label: "収縮補正",
          body: "Caraはロストワックス鋳造における金属固有の収縮率を考慮 — ゴールド、シルバー、プラチナ、ブラス — 最終製品がデジタルモデルと一致するよう設計。縮小した近似品ではありません。",
        },
        {
          stat: "0.6mm",
          label: "最小壁厚",
          body: "生成されるすべての形状は、合金固有の最小壁厚を遵守——プラチナ0.6mm、ゴールドとシルバー0.8mm。紙のように薄い爪も、崩壊するベゼルもありません。鋳造師の手に届く前に構造的に健全です。",
        },
        {
          stat: "4-Prong+",
          label: "ストーントレランスマッピング",
          body: "Caraはすべての石の種類とカットに対して、爪の配置、座の深さ、ガードルクリアランスを計算。日常使用での確実な保持のために設計 — 視覚的な妥当性だけではありません。",
        },
        {
          stat: "R≥0.4mm",
          label: "装着感・手触り",
          body: "Caraはバンドプロファイル、内側カーブ、重量配分、エッジ半径を評価し、すべてのピースが見た目と同じくらい快適であることを保証します。鋭いエッジ、トップヘビーなバランス、ピンチポイントは、デザインが画面を離れる前にフラグが立てられます。",
        },
      ],
      capabilities: [
        { label: "鋳造メカニクス", detail: "スプルー配置、ゲートサイジング、欠陥のない鋳造のためのフロー分析" },
        { label: "構造解析", detail: "応力テスト済みの壁厚と形態全体の荷重分布チェック" },
        { label: "部品表", detail: "コンセプト段階から正確な金属重量、石数、コスト見積もりを提供" },
        { label: "合金インテリジェンス", detail: "10K–24Kゴールド、925シルバー、950プラチナ、ブラスの材料特性" },
        { label: "プロダクションレディ", detail: "すべての出力は実際のEPH製造公差に対して評価" },
        { label: "スケッチtoCADブリッジ", detail: "ナプキンスケッチをアップロード — Caraがジオメトリを抽出し生産用に設計" },
      ],
      closing: "Caraエンジニアリングのコンセプトは、初回鋳造で成功するよう設計されています——手戻りなし、蠟の無駄なし、工場からの差し戻しなし。バイヤーがCaraコンセプトを見るとき、それは製造業者が適用するのと同じ制約条件でストレステスト済みの作品です。これが生成AIとエンジニアリングAIの違いです。",
      tryCara: "Cara AI を試す — ライブデモ",
      learnMore: "詳細を見る",
    },
    cta: {
      overline: "ソーシングを開始",
      heading: "トレードカタログを\nブラウズ。",
      body: "全スタンダードライセンスにEssentials Kit標準付属 — カタログ撮影・スペック・SEOコピーを即時提供。Caratzon Kitにアップグレードで、ライフスタイル撮影・ラインシート・SNSアセットも利用可能。3Dで評価し、従来のパイプラインより圧倒的に速く市場投入。",
      primary: "デザインを見る",
      secondary: "仕組みを見る",
      tradeOnly: "トレードアカウント限定",
    },
  },
  forManufacturers: {
    meta: {
      title: "プロダクション · Caratzon",
      description:
        "すべてのCaratzonオーダーはEPHで生産。中国最大の統合型ジュエリー製造ハブ — 5,000以上の製造業者、エコ認証プレーティング、CADからデリバリーまでのフルトレーサビリティ。",
    },
    hero: {
      overline: "プロダクション · EPH Manufacturing Hub",
      h1Line1: "ワンファシリティ。",
      h1Line2: "あらゆるケイパビリティ。",
      h1Line3: "5,000+の製造業者。",
      tagline:
        "すべてのCaratzonオーダーはEPH経由でルーティング — 中国最大の統合型ジュエリー製造ハブ。ワンルーフに5,000以上の製造業者、認証エコプレーティング、CADファイルから完成品までのフルトレーサビリティ。",
      cta: "カタログを見る",
    },
    stats: {
      cadReady: "5,000+",
      everyOrder: "ワンルーフの製造業者",
      phases: "フルチェーン",
      milestone: "鋳造 · 石留め · 研磨 · プレーティング · QC",
      ecoPlating: "エコ認証",
      ephCertified: "水処理施設完備",
      fullTrace: "フルトレース",
      clientVis: "ワックスプリントからデリバリーまで",
    },
    orderContents: {
      overline: "製造プロセス",
      subtitle: "ファイルから完成品まで",
      items: [
        {
          heading: "CADからワックスプリント",
          body: "生産ファイルはEPHへルーティングされ、フィジカルなワックスマスターに変換 — デジタルデザインからタンジブルなピースへの第一歩です。",
        },
        {
          heading: "キャスティング＆セッティング",
          body: "ロストワックスキャスティング、ストーンセッティング、アセンブリが同一ファシリティで完結。クロスファクトリーのハンドオフなし、トレランスの損失なし。",
        },
        {
          heading: "エコプレーティング＆フィニッシング",
          body: "認証エコラインでのゴールド・ロジウム・合金プレーティング、オンサイト水処理施設完備。スペックに応じたポリッシング＆フィニッシング。",
        },
        {
          heading: "QC＆デリバリー",
          body: "出荷前のマルチポイント品質管理。ダッシュボードで生産マイルストーンをリアルタイム確認、完了時にウェイビルを発行。",
        },
      ],
    },
    workflow: {
      overline: "プロダクションフェーズ",
      subtitle: "オーダーのステップバイステップ",
      phases: [
        ["オーダー確認", "デザインがEPH生産キューにエントリー"],
        ["NRE＆テストキャスト", "ワックスプリント作成、サンプルを承認用に提出"],
        ["キャスティング", "メタル鋳込み、ウェイト＆合金を検証"],
        ["セッティング＆アセンブリ", "ストーンセッティング、トレランスチェック、コンポーネントアセンブリ"],
        ["プレーティング＆フィニッシング", "スペックに応じたエコ認証プレーティングを適用"],
        ["QC＆シップ", "ファイナルマルチポイントインスペクション、ウェイビル発行"],
      ],
    },
    eph: {
      overline: "EPH Manufacturing Hub",
      location: "中国",
      headline: "5,000+の製造業者。ワンルーフ。フルサプライチェーン。",
      body: "EPHは中国最大の統合型ジュエリー製造ハブ — すべてのCaratzonオーダーのエクスクルーシブ生産ファシリティです。認証水処理施設、エコ認証プレーティングライン、ワンルーフのフルプロダクションチェーンにより、スケールでのサステナブルファインジュエリー製造のベンチマークを確立しています。",
      attrs: [
        {
          label: "統合型サプライチェーン",
          body: "キャスティング・セッティング・ポリッシング・プレーティングをシングルファシリティで完結。クロスファクトリーロジスティクスなし、ハンドオフロスなし。",
        },
        {
          label: "認証エコプレーティング",
          body: "オンサイト水処理施設を備えたエコ認証ラインでのゴールド・ロジウム・合金フィニッシュ — ケミカルディスチャージ削減を検証済み。",
        },
        {
          label: "スケール＆スペシャライゼーション",
          body: "ブライダルからオートクチュールまで、あらゆるジュエリーカテゴリーで深い専門性を持つ5,000以上の製造業者。",
        },
        {
          label: "ダイレクトデジタルインテグレーション",
          body: "CADファイルはCaratzonプラットフォームからEPHの生産キューへダイレクトルーティング — マニュアル再入力ゼロ、フルトレーサビリティ。",
        },
      ],
    },
    cta: {
      overline: "カタログを見る",
      heading: "プロデュース可能な\nデザインをご覧ください。",
      primary: "カタログを見る",
      secondary: "製造パートナーとして応募 →",
    },
    inquiryForm: {
      overline: "パートナー申請",
      heading: "製造ネットワークへの\nご参加を申請。",
      subtitle:
        "ファシリティとケイパビリティについてお知らせください。パートナーシップチームが申請を確認し、3営業日以内にご連絡いたします。",
      companyName: "会社名 / ファクトリー名",
      contactName: "ご担当者名",
      email: "ビジネスメールアドレス",
      phone: "電話番号",
      website: "会社Webサイト",
      location: "ファクトリー所在地（都市・国）",
      capabilities: "製造ケイパビリティ",
      capabilitiesHint: "該当するものをすべて選択してください",
      capabilityOptions: [
        "Casting",
        "Stone Setting",
        "Plating",
        "Polishing",
        "CAD/CAM",
        "CNC",
        "Assembly",
        "Engraving",
        "Enameling",
        "QC / Inspection",
      ],
      specializations: "ジュエリースペシャライゼーション",
      specializationsHint: "該当するものをすべて選択してください",
      specializationOptions: [
        "Rings",
        "Earrings",
        "Necklaces",
        "Bracelets",
        "Bridal",
        "Men's",
        "Watches",
        "Bespoke",
      ],
      certifications: "認証",
      certificationsHint: "該当するものをすべて選択してください",
      certificationOptions: [
        "RJC",
        "ISO 9001",
        "ISO 14001",
        "Hallmark",
        "Fairmined",
        "BSCI / Sedex",
      ],
      productionCapacity: "月間生産キャパシティ（ピース数）",
      capacityOptions: [
        "500未満",
        "500 – 2,000",
        "2,000 – 10,000",
        "10,000 – 50,000",
        "50,000+",
      ],
      additionalInfo: "追加情報",
      additionalInfoPlaceholder:
        "その他お知らせいただきたいこと — スペシャリティ、リードタイム、既存パートナーシップなど。",
      submit: "申請を送信",
      submitting: "送信中…",
      successHeading: "申請を受領いたしました",
      successBody:
        "Caratzon製造ネットワークへのご関心をいただきありがとうございます。パートナーシップチームが申請内容を確認し、3営業日以内にご連絡いたします。",
      errorRequired: "必須項目をすべてご入力ください。",
      errorEmail: "有効なメールアドレスをご入力ください。",
      errorSend: "エラーが発生しました。再度お試しいただくか、直接メールにてご連絡ください。",
    },
  },

  partnerApplication: {
    meta: {
      title: "パートナー申請 · Caratzon",
      description:
        "Caratzon製造ネットワークへのご参加を申請。ファシリティ、ケイパビリティ、認証についてお知らせください。",
    },
  },

  contact: {
    overline: "お問い合わせ",
    meta: {
      title: "お問い合わせ · Caratzon",
      description: "Caratzonチームにお問い合わせください。トレードデスク、デザイナー申請、一般的なお問い合わせ。",
    },
    heading: "Caratzonへのお問い合わせ",
    subtitle: "独占デザインを調達したいリテールブランドの方も、IPを収益化したい3D CADエンジニアの方も、グローバルチームがサポートいたします。",
    tabs: {
      brand: "ブランド / リテーラー",
      designer: "デザイナー",
      general: "一般 / プレス / 投資家",
    },
    brand: {
      headline: "トレードデスクに相談する",
      copy: "R&Dをスキップして製造を効率化しませんか？プラットフォームアクセス、大量調達、EPH製造能力についてご相談ください。",
      firstName: "名",
      lastName: "姓",
      workEmail: "業務用メールアドレス",
      companyName: "会社名 / ブランド名",
      companyWebsite: "会社ウェブサイト",
      helpWith: "ご相談内容",
      helpOptions: [
        "Source / Atelierプランへのアップグレード",
        "大量調達",
        "EPH製造能力",
        "Caratzon Studio AIデモ",
        "プラットフォームに関する質問",
      ] as readonly string[],
      selectPlaceholder: "トピックを選択…",
      message: "メッセージ",
      messagePlaceholder: "調達ニーズ、タイムライン、具体的なご質問をお聞かせください…",
      submit: "メッセージを送信",
      submitting: "送信中…",
    },
    designer: {
      headline: "Caratzonデザイナーネットワークに参加",
      copy: "グローバルライセンスマーケットプレイスで3D CADジュエリーデザインを収益化。ポートフォリオをアップロードし、条件を設定して、ブランドからのオファーを待ちましょう。",
      firstName: "名",
      lastName: "姓",
      email: "メールアドレス",
      portfolioUrl: "ポートフォリオ / Behance / Instagram URL",
      cadSoftware: "主要CADソフトウェア",
      cadOptions: [
        "Rhino / Grasshopper",
        "Matrix / MatrixGold",
        "ZBrush",
        "Blender",
        "SolidWorks",
        "その他",
      ] as readonly string[],
      selectPlaceholder: "主要ツールを選択…",
      designCount: "デザインの概数",
      designCountOptions: [
        "1–10",
        "11–50",
        "51–200",
        "200+",
      ] as readonly string[],
      designCountPlaceholder: "範囲を選択…",
      message: "あなたの作品について",
      messagePlaceholder: "デザインスタイル、専門分野、ライセンスパートナーシップに求めることをお聞かせください…",
      submit: "デザイナーとして申請",
      submitting: "送信中…",
    },
    general: {
      headline: "一般的なお問い合わせ",
      copy: "プレス、パートナーシップ、投資家向け情報については、コーポレートチームまでお問い合わせください。",
      name: "お名前",
      email: "メールアドレス",
      topic: "トピック",
      topicOptions: [
        "プレス・メディア",
        "投資家向け情報",
        "パートナーシップ",
        "その他",
      ] as readonly string[],
      selectPlaceholder: "トピックを選択…",
      message: "メッセージ",
      messagePlaceholder: "どのようにお手伝いできますか？",
      submit: "お問い合わせを送信",
      submitting: "送信中…",
    },
    success: {
      heading: "メッセージを受信しました",
      body: "お問い合わせいただきありがとうございます。24時間以内にチームメンバーが返信いたします。",
      backToHome: "ホームに戻る",
      explorePlatform: "プラットフォームを探索 →",
    },
    errors: {
      required: "必須項目をすべて入力してください。",
      invalidEmail: "有効なメールアドレスを入力してください。",
      sendFailed: "エラーが発生しました。再度お試しいただくか、hello@caratzon.comまで直接ご連絡ください。",
    },
    offices: {
      heading: "グローバルオフィス",
      hongkong: { city: "香港", label: "アジア太平洋トレードデスク" },
      guangdong: { city: "広東", label: "製造・オペレーション本部" },
      london: { city: "ロンドン", label: "ヨーロッパトレードデスク" },
    },
  },

  about: {
    meta: {
      title: "Caratzonについて — 私たちのストーリー",
      description:
        "Caratzonは、独立系ジュエリーデザイナーとワールドクラスのマニュファクチャリングを結ぶグローバルな双方向エコシステム。ジュエリーサプライチェーンの変革をご紹介します。",
    },
    hero: {
      overline: "Caratzonについて · Est. 2024",
      h1Line1: "比類なきデザインと",
      h1Line2: "完璧なエグゼキューションが",
      h1Line3: "出会う場所。",
      tagline:
        "Caratzonは、あるジュエリーブランドのホリデーシーズンを丸ごと危機に陥れた、たった1通の失われたメールスレッドから生まれました。今日、私たちは卓越した独立系デザイナーとワールドクラスのフルマネージドマニュファクチャリングを結ぶグローバルな双方向エコシステムです。",
      lastUpdated: "最終更新 2026年2月",
    },
    stats: {
      overline: "プラットフォームスケール",
      subtitle: "数字で見るCaratzon",
      items: [
        { value: "10,000+", label: "エクスクルーシブCADデザイン" },
        { value: "150+", label: "検証済み製造パートナー" },
        { value: "1M+", label: "オーケストレーションされた生産ノード" },
        { value: "$50M+", label: "クリエイターへの還元額" },
        { value: "0", label: "ブラックボックスサプライチェーン遅延" },
      ],
    },
    origin: {
      overline: "私たちの原点",
      subtitle: "すべてのプラットフォームには起源がある",
      p1: "Caratzonは日々、クリエイターがアートをマネタイズし、B2Bブランドが透明なノードベースサプライチェーンの確実性のもと、フレッシュでエクスクルーシブなコレクションをソーシングできる環境を提供しています。",
      p2: "私たちはグローバルソーシングのリスクと摩擦を排除するために存在します。ブランドが当プラットフォームのデザインに惚れ込んでも、製造方法を考える必要はありません。CaratzonがCADエンジニアリング、フィジカルプロトタイピング、マルチベンダーロジスティクス、品質管理、ファイナルデリバリーをエンドツーエンドで担当します。",
      digitalDesign: "デジタルデザイン",
      precisionCraft: "プレシジョンクラフト",
    },
    timeline: {
      overline: "Caratzonストーリー",
      subtitle: "4つのフェーズ",
      phases: [
        {
          heading: "壊れたチェーン",
          subheading: "ストーリーの始まり",
          label: "課題",
          body: "カスタムカットサファイア、精密ロストワックスキャスティング、スペシャルロジウムフィニッシュを要する、見事にデザインされたマルチコンポーネントピースから始まりました。2大陸にまたがる3つのファクトリーへCADファイルをルーティングした結果、ファクトリーが隠そうとした小さなポロシティ問題による大規模な遅延が発生。PDF請求書、WhatsApp更新、ブラインドトラストに依存するジュエリー業界は持続不可能であることが明白になりました。",
        },
        {
          heading: "閉じ込められた才能",
          subheading: "見過ごされていたマーケットの断絶",
          label: "インサイト",
          body: "同時に、マーケットにおける大きな断絶に気づきました。卓越した独立系ジュエリーデザイナーは息をのむ3D CADでハードドライブを満たしていましたが、ファクトリーコネクションも生産資本もゼロ。一方、大手B2Bリテールブランドはフレッシュなエステティクスを切望しながらも、未知のクリエイターを試すマニュファクチャリングリスクを恐れていました。アートとロジスティクスは根本的に相容れなかったのです。",
        },
        {
          heading: "オペレーティングシステムの構築",
          subheading: "中枢神経系のエンジニアリング",
          label: "ビルド",
          body: "究極のブリッジを構築することを決意。ジュエリーマニュファクチャリングの中枢神経系として機能する、独自のモジュラー・ノードベースプラットフォームをエンジニアリング。テクニカルデザイナーのビジョンを外部ファクトリーにダイレクト接続し、リアルタイムP&Lマージンをトラッキングし、あらゆるテクニカルスペックをセキュア化 — 個々のベンダーは完全にサイロ化されたままです。",
        },
        {
          heading: "究極のマーケットプレイス",
          subheading: "デザインと完璧なエグゼキューションの出会い",
          label: "アウトカム",
          body: "Caratzonはトラッキングツールとしてだけでなく、フルマネージドマニュファクチャリングエンジンに支えられたキュレーテッドデザイナーマーケットプレイスとして正式ローンチ。今日、ブランドが当プラットフォームのデザインに惚れ込んでも、製造方法を考える必要はありません。ワンクリックで、Caratzonがそのデザインを検証済みネットワーク経由で自動ルーティングし、CADエンジニアリング、フィジカルプロトタイピング、ファイナルQCを担当します。",
        },
      ],
    },
    vision: {
      overline: "ビジョン＆ミッション",
      visionLabel: "ビジョン",
      visionBody:
        "ワールドクラスのジュエリーデザインが完璧なエグゼキューションとシームレスに出会う、決定的なグローバルエコシステムとなること — 断片化されたサプライチェーンを、クリエイターとブランド双方にとって透明で高収益なエンジンへ変革すること。",
      missionLabel: "ミッション",
      missionBody:
        "独立系ジュエリーデザイナーを、フルマネージドマニュファクチャリングオペレーティングシステムに支えられたグローバルB2Bブランドとの接続によりエンパワーすること。グローバルソーシングのリスクと摩擦を排除するために私たちは存在します。",
    },
    howItWorks: {
      overline: "ご利用の流れ",
      subtitle: "ワンクリック。エンドツーエンド。",
      steps: [
        {
          heading: "デザイナーがアップロード",
          body: "独立系デザイナーがCADファイルをアップロードし、IPタームを設定し、エディトリアルストーリーを公開。作品は署名付き有効期限付きビューアURLで保護されます。",
        },
        {
          heading: "ブランドがディスカバー",
          body: "リテールブランドがキュレーテッドカタログで10,000以上のエクスクルーシブデザインをブラウズし、プラットフォーム内のインタラクティブ3Dビューアでピースをプレビュー。",
        },
        {
          heading: "Caratzonがルーティング",
          body: "合意後、ノードベースエンジンがデザインを検証済み製造ネットワーク経由で自動ルーティング — CADエンジニアリング、プロトタイピング、QC。",
        },
        {
          heading: "マージンでデリバリー",
          body: "リアルタイムP&Lビジビリティ、マイルストーントラッキング、ファイナルデリバリー — ブラックボックス遅延ゼロ、サプライチェーン全体のフルトランスペアレンシー。",
        },
      ],
    },
    leadership: {
      overline: "経営陣",
      founderRole: "ファウンダー＆CEO",
      founderName: "[ファウンダー名]",
      founderBio:
        "ジュエリーデザイン、サプライチェーンマネジメント、テクノロジーにおけるバックグラウンドと、Caratzonビジョンを駆動するものについての紹介。",
      tags: ["Jewelry Design", "Supply Chain", "Technology"],
    },
    supplyChain: {
      overline: "サプライチェーンアーキテクチャ",
      heading: "ノードベース。\nフルトランスペアレント。",
      items: [
        {
          title: "ベンダー完全サイロ化",
          desc: "個々のファクトリーノードは独立稼働。ベンダー間で他社のスペック・プライシング・キャパシティデータが共有されることはありません。",
        },
        {
          title: "リアルタイムP&L",
          desc: "各プロダクションマイルストーンでマージンビジビリティ — デザイナー・ブランド・マネージャーは各自のロールに関連するデータのみを閲覧。",
        },
        {
          title: "イミュータブルな監査証跡",
          desc: "すべてのCADバージョン、承認、プロダクションイベントがタイムスタンプ付きでログ — 完全なチェーンオブカストディを手元で確認可能。",
        },
      ],
    },
    quote: {
      text: "\"アートとロジスティクスは根本的に相容れなかった。\n私たちはそのブリッジを築いた。\"",
      attribution: "Caratzon · ファウンディングプリンシプル",
    },
    cta: {
      overline: "Caratzonとパートナーに",
      heading: "ファインジュエリーの\n未来を共に。",
      primary: "カタログを見る",
      secondary1: "ブランド・リテーラーの方へ →",
      secondary2: "独立系デザイナーの方へ →",
    },
  },
  forStudio: {
    meta: {
      title: "Caratzon Studio · Where AI Meets the Jeweler's Bench",
      description: "The AI-powered design workspace for jewelry creators. Meet Cara — your design assistant that thinks in millimeters, Mohs hardness, and tensile strength.",
    },
    hero: {
      overline: "Caratzon Studio",
      h1Line1: "Your Designs",
      h1Line2: "Deserve an Atelier.",
      tagline: "Caratzon Studio is the AI-powered workspace where independent jewelry designers upload CAD, tell their story, and let the platform handle everything else — marketing, licensing, production routing, and now, intelligent design assistance.",
      cta: "Apply as a Designer →",
      ctaSecondary: "See Pricing →",
    },
    stats: {
      aiAssisted: "AI-Assisted",
      designTools: "Design Tools",
      stoneTypes: "50+",
      stoneLabel: "Stone & Alloy Database",
      phases: "6",
      phasesLabel: "Sketch-to-Sales Steps",
      renders: "Instant",
      rendersLabel: "Catalog Renders",
    },
    cara: {
      overline: "Meet Cara",
      subtitle: "From Sketch to Sales",
      heading: "From Napkin Sketch\nTo Global Sales.",
      p1: "Cara is the AI design assistant that turns a hand-drawn sketch into a production-ready, market-listed piece of jewelry — handling every step from concept clarification to catalog renders, storytelling, and trade listing.",
      p2: "Snap a photo of your sketch. Cara asks the right questions — materials, dimensions, stone placement — then renders a faithful concept that respects your original vision down to every curve and proportion.",
      pipeline: [
        { num: "01", label: "Sketch", heading: "Upload Your Sketch", body: "Photograph a hand-drawn sketch or napkin doodle. Cara's vision model analyzes silhouettes, proportions, stone placements, and decorative details — extracting your intent with surgical precision.", icon: "pencil" },
        { num: "02", label: "Clarify", heading: "Intelligent Q&A", body: "Before touching a single pixel, Cara asks clarifying questions — metal type, stone cuts, ring size, finish preferences. Your answers become the design brief that locks in fidelity.", icon: "message-circle" },
        { num: "03", label: "Render", heading: "Faithful AI Render", body: "Cara generates a photorealistic concept that replicates your sketch with extreme fidelity — same silhouette, same proportions, same stone placement. Iterate through conversation until it's perfect.", icon: "image" },
        { num: "04", label: "Save", heading: "Save to Studio", body: "One click saves the approved render into your Studio as a new design draft — complete with the original sketch, conversation history, and all design parameters for future refinement.", icon: "save" },
        { num: "05", label: "Story", heading: "The Making Narrative", body: "Your sketch and the entire Cara conversation become the raw material for an AI-generated 'Making Of' story — a compelling editorial narrative that traces the creative journey from first line to final render.", icon: "book-open" },
        { num: "06", label: "Sell", heading: "List & Earn", body: "Catalog renders, lookbook assets, and trade listings are generated automatically. Your design enters the global catalog where brands discover, license, and order — and you earn 80% on every transaction.", icon: "trending-up" },
      ],
      conversationDemo: {
        label: "Cara — Sketch-to-Concept",
        userSketch: "I sketched this cocktail ring — can you turn it into a real concept?",
        caraAnalysis: "I can see a bold asymmetric band with what looks like a tension-set center stone and tapered shoulders. Before I render, let me clarify a few things:",
        caraQuestions: [
          "What metal are you envisioning? The angular lines suggest platinum or white gold",
          "The center stone — is that an emerald cut? Approximately what carat weight?",
          "I see texture marks on the band — brushed finish or hammered?",
        ],
        userReply: "Platinum, 2ct emerald-cut emerald, brushed finish on the band.",
        caraConfirm: "Perfect. Rendering your concept now — same silhouette, same proportions, platinum with brushed finish and a 2ct emerald-cut emerald in tension setting…",
        toolLabel: "Rendering faithful concept…",
      },
      cta: "Try Cara in Studio →",
    },
    storyLab: {
      overline: "AI Story Lab",
      subtitle: "Automated Storytelling",
      heading: "Your Story,\nTold Beautifully.",
      p1: "Answer seven guided questions during onboarding and our AI generates a rich editorial-style designer story, profile page, and lookbook — the kind of content that used to require a copywriter, photographer, and art director.",
      p2: "Each designer gets a dedicated Inspire profile where buyers discover your work through AI-generated narratives, not generic product listings.",
      features: [
        { label: "Editorial Profiles", description: "AI-generated designer stories that read like magazine features — not template bios." },
        { label: "AI Lookbooks", description: "Cohesive visual narratives across your portfolio, generated automatically from your designs." },
        { label: "Collection Storytelling", description: "Group pieces into themed collections and let AI weave a narrative across the set." },
      ],
    },
    workspace: {
      overline: "Designer Workspace",
      subtitle: "Everything in One Place",
      heading: "Upload. Manage.\nEarn.",
      p1: "The Studio workspace is your command center — upload CAD files, track licensing revenue, manage collections, monitor analytics, and communicate with buyers. All from one dashboard.",
      features: [
        { num: "01", heading: "3D Viewer", body: "Buyers inspect your designs in full 3D before licensing. Your CAD files are never exposed — only renders and previews." },
        { num: "02", heading: "Revenue Dashboard", body: "Track licensing fees, royalties, and production runs in real time. 80% revenue share on every license." },
        { num: "03", heading: "IP Protection", body: "CAD files are vault-encrypted and never shown to buyers. Structured licensing tiers with clear terms." },
        { num: "04", heading: "Direct Messaging", body: "Communicate with buyers and production managers directly inside the platform." },
      ],
    },
    revenue: {
      overline: "Revenue Models",
      subtitle: "Three Licensing Tiers",
      heading: "Earn on\nYour Terms.",
      models: [
        { tier: "standard", label: "Standard License", heading: "Non-Exclusive", description: "Multiple buyers can license the same design. You keep 80% of the licensing fee plus perpetual royalties on every production run.", benefit: "80% + Perpetual Royalties" },
        { tier: "embargo", label: "Seasonal Embargo", heading: "12-Month Exclusive", description: "One buyer gets competitor-proof exclusivity for a year. Higher upfront payment. After 12 months, the design returns to Standard availability.", benefit: "80% + Premium Exclusivity Fee" },
        { tier: "vault", label: "Full Exclusive", heading: "Permanent IP Transfer", description: "One-time buyout with permanent IP transfer including the CAD file. The highest upfront payment. Caratzon Kit included.", benefit: "Full Buyout + Caratzon Kit" },
      ],
    },
    steps: {
      overline: "Getting Started",
      subtitle: "Three Steps",
      items: [
        { heading: "Apply & Onboard", body: "Complete the seven-question onboarding flow. Our AI generates your editorial profile, designer story, and Inspire page automatically." },
        { heading: "Upload & Create", body: "Upload CAD files. Use Cara to refine designs, run structural analysis, and generate catalog-ready renders. Organize pieces into collections." },
        { heading: "Earn & Grow", body: "Buyers discover, license, and order your designs. You earn 80% on every license. Production is handled by our EPH-certified manufacturing hub." },
      ],
    },
    cta: {
      overline: "Join the Studio",
      heading: "Design the Future.\nWe Handle the Rest.",
      primary: "Apply as a Designer →",
      secondary: "Explore the Catalog →",
    },
  },

  studio: {
    nav: { guide: "ガイド", inbox: "受信トレイ", storyLab: "マイデザイン", collections: "コレクション", cara: "Cara", publishing: "パブリッシング", admin: "Admin →", catalog: "← カタログ", analytics: "アナリティクス" },
    notifications: { heading: "通知", empty: "通知はまだありません。" },
    cara: {
      title: "Cara",
      subtitle: "AIデザインアシスタント",
      newSession: "新しいデザインセッション",
      placeholder: "ビジョンを説明するか、インスピレーション画像をアップロードしてください…",
      emptyTitle: "Caraに会いましょう",
      emptyDescription: "あなたのAIデザインアシスタント — マスタージュエラーとメカニカルエンジニアを兼ね備えています。ビジョンを説明するか、インスピレーション画像をアップロードして始めましょう。",
      analyzing: "インスピレーションを分析中…",
      rendering: "デザインレンダーを生成中…",
      structuralAnalysis: "製造可能性シミュレーションを実行中…",
      calculatingBom: "部品表を計算中…",
      generatingVideo: "ターンテーブルプレビューを生成中 — 最大1分かかる場合があります…",
      processing: "処理中…",
      phases: { spark: "スパーク", architect: "アーキテクト", crucible: "クルーシブル", bench: "ベンチ" },
      artifacts: {
        title: "アーティファクト",
        empty: "Caraが生成するとアーティファクトがここに表示されます。",
        moodBoards: "ムードボード",
        renders: "デザインレンダー",
        structuralAnalysis: "構造分析",
        materialAnalysis: "素材分析",
        bom: "部品表",
        videos: "動画",
      },
      sessions: { empty: "セッションなし", emptyHint: "Caraとの最初のデザインセッションを始めましょう", untitled: "無題のセッション" },
      errors: { streamFailed: "エラーが発生しました。もう一度お試しください。", rateLimited: "メッセージの送信が速すぎます。少々お待ちください。" },
    },
    gettingStarted: {
      overline: "Designer Studio",
      title: "はじめに",
      subtitle: "3つのコア機能のビジュアルガイド。開始前にエンドツーエンドのフローを把握できます。",
      howItWorks: {
        title: "ご利用の流れ",
        steps: [
          {
            title: "アップロード＆クリエイト",
            label: "マイデザイン",
            body: "CADファイルとサポートアセットをアップロード。AIがパブリケーションレディのカタログストーリーを生成します。",
          },
          {
            title: "リクエストに対応",
            label: "受信トレイ",
            body: "ブランドからのカスタマイズリクエストに対応。コラボレーション、条件交渉、修正CADの納品をワンスレッドで管理。",
          },
          {
            title: "コレクションをキュレーション",
            label: "コレクション",
            body: "公開済みデザインをテーマ別のエディトリアルコレクションにグルーピング。AIが個々のストーリーを一貫したナラティブに統合します。",
          },
        ],
      },
      storyLabWorkflow: {
        title: "デザインワークフロー",
        subtitle: "2つのフェーズでCADファイルを公開済みInspireページへ変換します。",
        phase1: {
          title: "フェーズ1 — デザインドラフト",
          subtitle: "5ステップのウィザードで、AIが処理する前にプラットフォームが必要とする情報をすべて収集します。",
          steps: [
            { title: "アイデンティティ", body: "作品に名前を付け、簡潔な説明を記述します。" },
            { title: "プライシング＆スペック", body: "ベースライセンス価格、メタルウェイト、ストーンカウントを設定します。" },
            { title: "IPプロテクション", body: "スタンダード、シーズナルエンバーゴ、完全独占権のいずれかを選択します。" },
            { title: "アセットアップロード", body: "プロダクションCAD、3Dビューアファイル、ヒーローレンダーをアップロードします。" },
            { title: "レビュー＆クリエイト", body: "内容を確認し、デザインドラフトを作成します。" },
          ],
        },
        phase2: {
          title: "フェーズ2 — AIストーリー",
          subtitle: "6ステップでドラフトをAI生成のナラティブ＆イメージリーでカタログレディのストーリーに変換します。",
          steps: [
            { title: "インスピレーションキーワード", body: "リファレンスフォトをアップロード。AIがムード・素材・テーマを分析します。" },
            { title: "キーワード選択", body: "作品のエッセンスを最もよく表すワードを選択します。" },
            { title: "ストーリー生成", body: "素材とインテントを記述。AIがカタログ用ナラティブを作成します。" },
            { title: "ストーリーリファイン", body: "AIドラフトを編集 — このテキストがバイヤーが読む内容です。" },
            { title: "ショーケース生成", body: "AIがセクション・ヘッドライン・イメージスロットでカタログスプレッドを構築します。" },
            { title: "承認申請", body: "編集をロックし、レビューチームに送信します。" },
          ],
        },
      },
      afterSubmission: {
        title: "送信後の流れ",
        body: "管理者がストーリーとショーケースをレビューします。承認されたデザインはトレードカタログで公開。リジェクトの場合はフィードバックとともに返却されます。",
        steps: [
          { label: "送信済み", body: "デザインがレビューキューにエントリーします。" },
          { label: "レビュー済み", body: "管理者がストーリークオリティとアセットの完全性を評価します。" },
          { label: "公開済み", body: "承認されたデザインがトレードカタログに掲載され、ブランドがディスカバー可能になります。" },
        ],
      },
      fileRequirements: {
        title: "ファイル要件",
        subtitle: "対応フォーマットとサイズリミットのクイックリファレンス。",
        columns: { asset: "アセット", formats: "フォーマット", maxSize: "最大サイズ", required: "必須" },
        rows: [
          { asset: "プロダクションCAD", formats: ".stl, .3dm, .step", maxSize: "50 MB", required: "はい" },
          { asset: "3Dビューア", formats: ".glb", maxSize: "25 MB", required: "はい" },
          { asset: "ヒーローレンダー", formats: ".jpg, .png, .webp", maxSize: "10 MB", required: "はい" },
          { asset: "リファレンスフォト", formats: ".jpg, .png, .webp", maxSize: "各5 MB", required: "任意" },
        ],
      },
      ipTiers: {
        title: "IPティアの解説",
        subtitle: "3つのライセンスモデル — 目標に合わせてお選びください。",
        tiers: [
          {
            title: "スタンダードライセンス",
            body: "CADはCaratzonが保持し、NDA下の認定マニュファクチャラーにのみ提供。ライセンス料の80%と永続的ロイヤリティを獲得。複数ブランドが同時にライセンス可能です。",
          },
          {
            title: "シーズナルエンバーゴ",
            body: "1ブランドが12ヶ月間の独占権を保有。期間中はデザインが非表示となり、エンバーゴ終了後にマーケットプレイスに復帰。プレミアムプライシングが適用されます。",
          },
          {
            title: "完全独占権",
            body: "ブランドがIPを恒久的に取得。プロダクションCADが直接譲渡されます。ワンタイムの高額トランザクション — デザインはマーケットプレイスから恒久的に削除されます。",
          },
        ],
      },
      cta: {
        title: "準備はできましたか？",
        button: "最初のデザインを始める",
      },
    },
    storyLab: {
      overline: "Designer Studio",
      title: "マイデザイン",
      subtitle: "デザインをアップロードし、AIストーリーを生成してInspireページに公開。",
      newDraft: "新規デザインドラフト",
      overlineLabel: "マイデザイン",
      cancel: "キャンセル",
      continue: "次へ",
      back: "戻る",
      stepOf: "ステップ {current} / {total}",
      keyboardHint: "ヒント：Alt + 矢印キーでステップを移動",
      editing: "編集中…",
      draftInProgress: "ドラフト作成中",
      emptyTitle: "デザインはまだありません",
      emptySubtitle: "最初のデザインをアップロードして、Inspireポートフォリオの構築を開始しましょう。",
      newDesign: "新規デザイン",
      emptyHint: "またはサイドバーから既存のデザインを選択",
      batchUpload: "一括アップロード",
      batchUploadSubtitle: "最大20枚のジュエリーフォトをドロップ — AIが各ピースのタイトル・説明・キーワードを生成",
      batchProcessing: "{count}点を処理中…",
      batchGenerate: "{count}デザインを生成",
      batchCreated: "{count}デザインを作成しました",
      batchDuplicates: "{count}件の重複をスキップ",
      batchPossibleDuplicates: "{count}件の重複の可能性",
      batchFailed: "{count}件が失敗",
      batchDuplicateExact: "「{title}」として既にアップロード済み",
      batchDuplicateNear: "「{title}」に類似の可能性（{confidence}%マッチ）",
      batchViewInLab: "マイデザインで表示",
      batchDropHere: "最大20枚のジュエリーフォトをここにドロップ",
      batchDropHint: "AIが各ピースのタイトル・説明・キーワードを生成します",
      celebrationTitle: "デザインドラフトを作成しました！",
      celebrationSubtitle: "デザインの準備が完了。下のキーワード生成からストーリー構築を開始してください。",
      selectDesign: "続行するデザインを\n選択してください",
      selectDesignHint: "パネルからドラフトを選択するか、新規デザインを作成してください。",
      sidebar: { newDesign: "+ 新規デザイン", designs: "デザイン", noDesigns: "デザインはまだありません" },
      steps: {
        identity: {
          title: "作品に名前を付ける",
          subtitle: "デザインにタイトルとエッセンスを捉えた簡潔な説明を付けます。バイヤーが最初に目にする内容です。",
          designTitle: "デザインタイトル",
          titleTip: "Caratzonマーケットプレイスでのパブリックネームになります。エヴォカティブで記憶に残る名前を — バイヤーはまずタイトルでブラウズします。",
          titlePlaceholder: "例：Lunette Drop Earrings",
          titleHint: "作品のエッセンスを捉えた名前をお選びください",
          description: "簡潔な説明",
          descriptionPlaceholder: "ピースとそのキャラクターを1〜2文で。",
          descriptionHint: "カタログに表示されます。印象的かつ簡潔に。",
        },
        pricing: {
          title: "プライシング＆スペック",
          subtitle: "ベースライセンス価格を設定し、素材スペックをご入力ください。バイヤーのコスト評価とマニュファクチャラーの見積もり作成に役立ちます。",
          basePrice: "ベースプライス（USD）",
          basePriceTip: "ライセンスフィーです。ブランドがデザインを使用するために支払う金額。プラットフォームフィー控除後、80%を受け取ります。",
          basePriceHint: "ブランドが支払うデザインライセンスフィー。80%を獲得。",
          metalWeight: "メタルウェイト（グラム）",
          metalWeightTip: "概算ウェイトはマニュファクチャラーの生産コスト見積もりに役立ちます。",
          metalWeightHint: "デザイン内のメタル概算ウェイト",
          stoneCount: "ストーンカウント",
          stoneCountHint: "ピースにセットされたストーンの合計数",
          howPricingWorks: "プライシングの仕組み：",
          howPricingBody: "ベースプライスはデザインライセンスフィーです。製造コストはメタルウェイト・ストーン・複雑さに基づき、認定ファクトリーが別途見積もります。",
        },
        licensing: {
          title: "IPプロテクションを選択",
          subtitle: "ブランドがデザインをどのように使用できるか選択します。各ティアで異なるプロテクションレベルとレベニューモデルを提供。",
          licensingTip: "IPティアがブランドのデザイン使用条件を決定します。スタンダードは複数ライセンス可、エクスクルーシブは1ブランドにテンポラリー権利、Vaultはフルオーナーシップを譲渡。",
          standard: "スタンダードライセンス",
          standardDesc: "CADはCaratzonが保持し、NDA下の認定マニュファクチャラーにのみ提供。ライセンス料の80%と永続的ロイヤリティを獲得。",
          standardDetail: "継続的なパッシブインカムを目指すデザイナー向け。複数ブランドが同時にライセンス可能。",
          exclusive: "シーズナルエンバーゴ",
          exclusiveDesc: "1ブランドが12ヶ月間の独占権を保有。期間中はデザインが非表示。エンバーゴ終了後にマーケットに復帰。",
          exclusiveDetail: "エクスクルーシビティのプレミアムプライシング。ブランドはエンバーゴ期間のため高めのライセンスフィーを支払います。",
          vault: "完全独占権",
          vaultDesc: "ブランドがIPを恒久的に取得。プロダクションCADが直接譲渡。アクイジションプライスの80%を獲得。",
          vaultDetail: "ワンタイムの高額トランザクション。デザインはマーケットプレイスから恒久的に削除。",
          ipTransfer: "IP譲渡",
        },
        assets: {
          title: "アセットをアップロード",
          subtitle: "バイヤーとマニュファクチャラーに必要なデザインファイルをアップロード。プロダクションCADはプロテクトされ、NDA下の認定マニュファクチャラーのみが閲覧可能です。",
          assetsTip: "プロダクションCADはバイヤーに共有されません。Caratzon認定マニュファクチャラーのみが厳格なNDAタームでアクセスします。",
          requiredFiles: "必須ファイル",
          optionalFiles: "任意 — AIストーリークオリティ向上",
          vaultNotice: "完全独占権。",
          vaultNoticeDetail: "CADはアクワイアリングブランドに直接譲渡されます。",
          cadProtected: "CADはIPプロテクト済み。",
          cadProtectedDetail: "Caratzon認定マニュファクチャラーのみがNDA下で受領。",
          cadLabel: "プロダクションCAD",
          cadLabelVault: "IP譲渡用プロダクションCAD",
          cadHint: ".stl · .3dm · .step — ソースファイル、バイヤーには非共有",
          viewerLabel: "3Dビューアアセット",
          viewerHint: ".glb — インタラクティブバイヤープレビュー用のCADエクスポート",
          renderLabel: "2Dレンダー / ヒーローイメージ",
          renderHint: ".jpg · .png · .webp — メインカタログサムネイル",
        },
        review: {
          title: "レビュー＆クリエイト",
          submit: "デザインドラフトを作成",
          submitting: "作成中…",
          identity: "アイデンティティ",
          pricingSpecs: "プライシング＆スペック",
          licensingTier: "ライセンスティア",
          assets: "アセット",
          edit: "編集",
          uploaded: "アップロード済み",
          missing: "未アップロード",
          allRequired: "作成前にすべての必須ファイルをアップロードしてください。",
        },
      },
      workflow: {
        featured: "フィーチャード",
        revisionRequired: "修正が必要です",
        revisionHint: "上記のフィードバックに対応してから再送信してください。",
        noReason: "理由が記載されていません。",
        step01: "インスピレーションキーワード",
        step01Sub: "リファレンスフォトをアップロードし、コンテキストを追加。AIがムード・素材・テーマを分析してキーワードパレットを構築します。",
        additionalContext: "追加コンテキスト",
        contextPlaceholder: "例：アールデコの影響、ミッドナイトブルーサファイア…",
        generateKeywords: "キーワードを生成",
        regenerateKeywords: "キーワードを再生成",
        analysingRefs: "リファレンスを分析中…",
        step02: "キーワード選択",
        step02Sub: "この作品のエッセンスを最もよく表すワードを選択 — AI生成ストーリーのアンカーになります。",
        saveKeywords: "選択キーワードを保存",
        saving: "保存中…",
        step03: "ストーリー生成",
        step03Sub: "素材・インテント・隠されたミーニングを記述。AIがカタログページに表示されるナラティブを作成します。",
        pieceDescription: "ピースの説明",
        describePlaceholder: "デザインについて記述してください",
        materialsColors: "素材＆カラー",
        materialsPlaceholder: "ファインシルバー、パヴェダイヤモンド…",
        initialSpark: "インスピレーションの源",
        sparkPlaceholder: "イメージ、記憶、ムード…",
        hiddenSymbolism: "秘められたシンボリズム",
        symbolismPlaceholder: "この作品に込められた意味は？",
        generateStory: "ストーリーを生成",
        regenerateStory: "ストーリーを再生成",
        writingStory: "ストーリーを執筆中…",
        step04: "ストーリーリファイン",
        step04Sub: "AIドラフトをレビュー。タイトルとボディを自由に編集 — このテキストがバイヤーがカタログページで読む内容です。",
        saveStory: "ストーリーを保存",
        step05: "ショーケース生成",
        step05Sub: "AIがカタログスプレッドを構築 — セクション数・イメージスロット・ヘッドライン。すべてストーリーから生成。",
        currentLayout: "現在のレイアウト：",
        sections: "セクション",
        generatedImages: "生成イメージ",
        generatedImagesPlural: "生成イメージ",
        regenerateWarning: "再生成すると現在のレイアウトが置き換わります。",
        generateShowcase: "ショーケースを生成",
        regenerateShowcase: "ショーケースを再生成",
        buildingShowcase: "ショーケースを構築中…",
        step06: "承認申請",
        step06Sub: "管理者がストーリーとショーケースをレビューするまで編集をロック。決定時に通知されます。",
        awaitingReview: "デザインはレビューチームに送信済みです。決定時に通知されます。",
        submitForApproval: "承認申請を送信",
        awaitingAdmin: "管理者レビュー待ち…",
        published: "公開済み",
        submitting: "送信中…",
        viewPublished: "公開ストーリーを表示",
      },
      upload: {
        dragOrClick: "ここにドラッグ、または",
        clickToBrowse: "クリックしてブラウズ",
        maxSize: "最大 {size} MB",
        required: "必須",
        uploading: "{name}をアップロード中…",
        replace: "差し替え",
        retry: "リトライ",
        demoPreLoaded: "デモファイルがプリロード済み",
        photoRefs: "フォトリファレンス",
        photoRefsHint: "— 任意、AIクオリティ向上",
        dragOrClickPhotos: "ドラッグまたはクリックでリファレンスフォトを追加",
        upToPhotos: "最大{max}枚",
        remove: "削除",
        inspirationNotes: "インスピレーションノート",
        inspirationPlaceholder: "記憶、雰囲気、感情のキュー、具体的なきっかけ。",
      },
    },
    collections: {
      overline: "Designer Studio",
      title: "コレクション",
      subtitle: "公開済みデザインをキュレーテッドコレクションにまとめ、AI生成のエディトリアルストーリーを付加。",
      newCollection: "新規コレクション",
      emptyTitle: "最初のコレクションをお待ちしています",
      emptySubtitle: "2つ以上の公開済みデザインを選択してコレクションを作成。AIがストーリーを統合します。",
      emptyHint: "またはサイドバーから既存のコレクションを選択",
      celebrationTitle: "コレクションを作成しました！",
      celebrationSubtitle: "コレクションの準備が完了。下のキーワード生成からストーリーワークフローを開始してください。",
      sidebar: { collections: "コレクション", noCollections: "コレクションはまだありません" },
      designPicker: {
        title: "コレクションピース",
        subtitle: "含める公開デザインを選択。最低2デザインが必要です。",
        selected: "{count}件選択",
        minRequired: "最低2デザインを選択してください",
        saveDesigns: "ピースを保存",
        saving: "保存中…",
      },
      create: {
        title: "コレクションを作成",
        collectionTitle: "コレクションタイトル",
        titlePlaceholder: "例：Midnight Oceanic Series",
        description: "簡潔な説明",
        descriptionPlaceholder: "コレクションのテーマについて数文。",
        selectDesigns: "デザインを選択",
        selectDesignsHint: "公開済みデザインから最低2つ選択してください",
        inspirationNote: "インスピレーションノート",
        inspirationNotePlaceholder: "これらの作品を結びつけるものは？",
        submit: "コレクションを作成",
        submitting: "作成中…",
      },
      draftNotInitialized: "コレクションドラフトが初期化されていません。",
      draftNotInitializedCta: "コレクションに戻る",
      workflow: {
        step00: "コレクションピース",
        step00Sub: "このコレクションに含めるデザインを管理します。",
        step01: "コレクションキーワード",
        step01Sub: "AIが全ピースをまとめて分析し、統一テーマ・モチーフ・ムードを発見します。",
        additionalContext: "追加コンテキスト",
        contextPlaceholder: "例：共通のクリエイティブシーズン、素材パレット、エモーショナルスレッド…",
        generateKeywords: "キーワードを生成",
        regenerateKeywords: "キーワードを再生成",
        analysingCollection: "コレクションを分析中…",
        step02: "キーワード選択",
        step02Sub: "このコレクションのエッセンスを最もよく表すワードを選択してください。",
        saveKeywords: "選択キーワードを保存",
        saving: "保存中…",
        step03: "コレクションストーリー生成",
        step03Sub: "AIが個々のデザインストーリーを一貫したコレクションナラティブに統合します。",
        generateStory: "ストーリーを生成",
        regenerateStory: "ストーリーを再生成",
        writingStory: "コレクションストーリーを執筆中…",
        step04: "ストーリーリファイン",
        step04Sub: "生成されたコレクションナラティブをレビュー・編集。",
        saveStory: "ストーリーを保存",
        step05: "ショーケース生成",
        step05Sub: "AIが各セクションのイメージ付きマルチピースエディトリアルショーケースをデザインします。",
        currentLayout: "現在のレイアウト：",
        sections: "セクション",
        generatedImages: "生成イメージ",
        generatedImagesPlural: "生成イメージ",
        regenerateWarning: "再生成すると現在のレイアウトが置き換わります。",
        generateShowcase: "ショーケースを生成",
        regenerateShowcase: "ショーケースを再生成",
        buildingShowcase: "ショーケースを構築中…",
        step06: "承認申請",
        step06Sub: "管理者がコレクションストーリーとショーケースをレビューするまで編集をロック。",
        awaitingReview: "コレクションはレビューチームに送信済みです。決定時に通知されます。",
        submitForApproval: "承認申請を送信",
        awaitingAdmin: "管理者レビュー待ち…",
        published: "公開済み",
        submitting: "送信中…",
        viewPublished: "公開コレクションを表示",
        revisionRequired: "修正が必要です",
        revisionHint: "上記のフィードバックに対応してから再送信してください。",
        noReason: "理由が記載されていません。",
        featured: "フィーチャード",
      },
    },
    inbox: {
      title: "カスタマイズ受信トレイ",
      subtitle: "条件交渉、ブリーフレビュー、修正CADのアップロード。",
      overline: "Designer Studio",
      openRequests: "オープンリクエスト",
      emptyTitle: "アクティブなリクエストはありません",
      emptySubtitle: "ブランドがデザインのカスタマイズリクエストを送信すると、ここに表示されます。",
      selectRequest: "サイドバーからリクエストを選択して開始してください。",
      thread: "スレッド",
      noMessages: "メッセージはまだありません。",
      updateStatus: "ステータスを更新",
      uploadRevision: "CADリビジョンをアップロード",
      revisionHint: "CADリビジョンのアップロードを有効にするには、リクエストをIn Progressに変更してください。",
    },
    analytics: {
      overline: "Studio",
      title: "デザインアナリティクス",
      subtitle: "デザインのパフォーマンスをトラッキング — ビュー、エンゲージメント、オーディエンスリーチ。",
      cards: {
        totalViews: "トータルビュー",
        uniqueVisitors: "ユニークビジター",
        avgTimeOnPage: "平均滞在時間",
        quoteRequests: "見積もりリクエスト",
      },
      table: {
        design: "デザイン",
        views: "ビュー",
        uniqueViews: "ユニーク",
        clicks: "クリック",
        avgTime: "平均時間",
        scrollDepth: "スクロール深度",
      },
      drillDown: {
        viewsTrend: "ビュートレンド（30日間）",
        clickBreakdown: "クリック内訳",
        referrerBreakdown: "リファラーソース",
      },
      empty: "アナリティクスデータはまだありません。デザインが公開されビューが発生すると、メトリクスがここに表示されます。",
      seconds: "秒",
    },
  },
  catalog: {
    overline: "トレードカタログ",
    resultCount: "{count}件の結果",
    designCount: "{count}デザイン",
    emptyTitle: "カタログをキュレーション中です",
    emptySubtitle: "デザイナーが最初のコレクションを準備しています。まもなく公開予定です。",
    searchEmptyTitle: "一致する結果がありません",
    searchEmptySubtitle: "別のクエリをお試しいただくか、全デザインをブラウズしてください。",
    browseCta: "全デザインをブラウズ",
  },

  orders: {
    overline: "トレードワークスペース",
    title: "ソーシングオーダー",
    subtitle: "アクティブなネゴシエーションをトラッキングし、デザイナーからの修正3Dプルーフをレビュー、プロダクションルーティング用のサブミッションを承認。",
    activeOrders: "アクティブオーダー",
    emptyTitle: "ソーシングオーダーはまだありません",
    emptyCta: "トレードカタログを見る →",
    selectOrder: "ネゴシエーションスレッドを表示するオーダーを選択してください。",
    latestRevision: "最新CADリビジョン — 3Dプレビュー",
    awaitingRevision: "デザイナーの最初のCADリビジョンをお待ちしています。",
    respondToDesigner: "デザイナーに返信",
  },

  admin: {
    brand: "Admin",
    nav: { workflows: "ワークフロー", publishing: "パブリッシング", users: "ユーザー", academy: "アカデミー", developer: "デベロッパー", queues: "キューモニター", catalog: "カタログ", studio: "Studio", analytics: "アナリティクス", catalogAdmin: "カタログ", catalogListings: "トレードリスティング", inspireAdmin: "Inspire", storyLab: "マイデザイン" },
    users: {
      overline: "Admin",
      title: "ユーザー管理",
      subtitle: "全ロールのアカウントを作成・編集・管理。",
      tabs: { users: "ユーザー", createNew: "新規作成" },
      stats: { total: "総ユーザー数", active: "アクティブ", suspended: "サスペンド中", designers: "デザイナー" },
      search: "名前またはメールで検索…",
      allRoles: "全ロール",
      noMatch: "フィルターに一致するユーザーはいません。",
      columns: { name: "名前", email: "メール", role: "ロール", status: "ステータス", actions: "アクション" },
      statusActive: "アクティブ",
      statusSuspended: "サスペンド中",
      edit: "編集",
      suspend: "サスペンド",
      reactivate: "再アクティベート",
      roles: {
        DESIGNER: "デザイナー",
        B2B_BUYER: "ブランド / バイヤー",
        MANUFACTURER: "マニュファクチャラー",
        PRODUCTION_MANAGER: "プロダクションマネージャー",
        ADMIN: "Admin",
      },
      roleLabels: { DESIGNER: "デザイナー", B2B_BUYER: "ブランド", MANUFACTURER: "ファクトリー", PRODUCTION_MANAGER: "PM", ADMIN: "Admin" },
      create: {
        title: "アカウント作成",
        subtitle: "新規デザイナー・バイヤー・マニュファクチャラー・スタッフメンバーを追加。",
        name: "氏名",
        namePlaceholder: "例：Aria Atelier",
        email: "メールアドレス",
        emailPlaceholder: "designer@example.com",
        password: "パスワード",
        passwordPlaceholder: "8文字以上",
        role: "ロール",
        submit: "アカウントを作成",
      },
      invite: {
        title: "招待リンクを送信",
        subtitle: "特定のメール＆ロール用のサインアップリンクを生成。7日間有効です。",
        email: "メール",
        emailPlaceholder: "new-designer@example.com",
        role: "ロール",
        submit: "リンクを生成",
        copied: "コピーしました！",
        copy: "コピー",
      },
      editDialog: {
        title: "ユーザーを編集",
        subtitle: "アカウント詳細とロールアサインメントを更新。",
        name: "名前",
        email: "メール",
        role: "ロール",
        save: "変更を保存",
        cancel: "キャンセル",
        stripe: "Stripe",
        accountActions: "アカウントアクション",
        resetPassword: "パスワードをリセット",
        deleteAccount: "アカウントを削除",
      },
      confirm: {
        suspendTitle: "ユーザーをサスペンド",
        suspendDesc: "{name}をサスペンドしますか？直ちにプラットフォームへのアクセスが停止されます。",
        suspendButton: "サスペンド",
        reactivateTitle: "ユーザーを再アクティベート",
        reactivateDesc: "{name}を再アクティベートしますか？フルアクセスが復元されます。",
        reactivateButton: "再アクティベート",
        deleteTitle: "ユーザーを削除",
        deleteDesc: "{name}を完全に削除しますか？この操作は取り消せず、関連するすべてのデータが削除されます。",
        deleteButton: "完全に削除",
        cancel: "キャンセル",
      },
      success: {
        created: "ユーザーアカウントを作成しました。",
        updated: "ユーザー詳細を更新しました。",
        suspended: "ユーザーアカウントをサスペンドしました。",
        reactivated: "ユーザーアカウントを再アクティベートしました。",
        deleted: "ユーザーアカウントを削除しました。",
        reset: "テンポラリーパスワードを生成しました。",
        invited: "招待リンクを生成しました。",
      },
      tempPasswordHint: "今すぐコピーしてください — 再表示されません。",
      dismiss: "閉じる",
    },
    setup: {
      title: "プラットフォームセットアップ",
      subtitle: "最初の管理者アカウントを作成して開始します。",
      steps: { authorize: "認証", credentials: "クレデンシャル", designer: "デザイナー", confirm: "確認" },
      setupPasswordLabel: "セットアップパスワード",
      setupPasswordPlaceholder: "セットアップパスワードを入力",
      setupPasswordHint: "このインスタンスでは最初の管理者アカウント作成にセットアップパスワードが必要です。",
      setupPasswordInvalid: "セットアップパスワードが正しくありません。",
      emailLabel: "メールアドレス",
      emailPlaceholder: "admin@company.com",
      nameLabel: "氏名",
      namePlaceholder: "Jane Smith",
      passwordLabel: "パスワード",
      passwordPlaceholder: "8文字以上",
      confirmPasswordLabel: "パスワード確認",
      confirmPasswordPlaceholder: "パスワードを再入力",
      designerTitle: "デザイナーアカウント",
      designerSubtitle: "デザインのアップロードを開始できる最初のデザイナーアカウントを作成します。",
      designerNameLabel: "デザイナー名",
      designerNamePlaceholder: "Aria Atelier",
      designerEmailLabel: "デザイナーメール",
      designerEmailPlaceholder: "designer@company.com",
      designerPasswordLabel: "デザイナーパスワード",
      designerPasswordPlaceholder: "8文字以上",
      reviewTitle: "確認",
      reviewSubtitle: "作成するアカウントをご確認ください。",
      createAccount: "アカウントを作成",
      back: "戻る",
      next: "次へ",
      passwordMismatch: "パスワードが一致しません。",
      passwordTooShort: "パスワードは8文字以上である必要があります。",
    },
    analytics: {
      overline: "Admin",
      title: "プラットフォームアナリティクス",
      subtitle: "プラットフォーム全体のデザインエンゲージメントメトリクスとパフォーマンスインサイト。",
      cards: {
        totalViews: "トータルビュー",
        uniqueVisitors: "ユニークビジター",
        avgTimeOnPage: "平均滞在時間",
        totalClicks: "トータルクリック",
      },
      filters: {
        designer: "デザイナーでフィルター",
        dateRange: "期間",
        allDesigners: "全デザイナー",
      },
      leaderboard: "トップパフォーマンスデザイン",
      zeroEngagement: "要注目（エンゲージメントゼロ）",
      table: {
        design: "デザイン",
        designer: "デザイナー",
        views: "ビュー",
        uniqueViews: "ユニーク",
        clicks: "クリック",
        avgTime: "平均時間",
        scrollDepth: "スクロール深度",
      },
      drillDown: {
        viewsTrend: "ビュートレンド",
        clickBreakdown: "クリック内訳",
        referrerBreakdown: "リファラーソース",
      },
      empty: "アナリティクスデータはまだありません。デザインが公開されビューが発生すると、メトリクスがここに表示されます。",
      seconds: "秒",
    },
  },
  messages: {
    overline: "コミュニケーション",
    title: "メッセージ",
    subtitle: "デザイナー、プロダクションマネージャー、マニュファクチャリングパートナーとの会話。",
    emptyTitle: "会話はまだありません",
    emptyCta: "カタログをブラウズして始めましょう",
    typeMessage: "メッセージを入力…",
    send: "送信",
    translate: "翻訳",
    translating: "翻訳中…",
    loadMore: "以前のメッセージを読み込む",
    typing: "入力中…",
    typingMultiple: "入力中…",
    today: "今日",
    yesterday: "昨日",
    unread: "未読",
    newConversation: "新規会話",
    participants: "参加者",
    quoteProposal: "見積もり提案",
    statusUpdate: "ステータス更新",
    attachFile: "ファイルを添付",
    accept: "承諾",
    counter: "カウンター",
    connecting: "チャットに接続中…",
    estimatedDays: "納期目安",
    days: "日",
    messageDesigner: "デザイナーにメッセージ",
  },

  pricing: {
    meta: {
      title: "料金プラン · Caratzon",
      description: "Caratzonのブランド向け透明な料金体系——プレエンジニアードジュエリーデザインの調達、AIマーケティングキットの生成、サステナブルな製造。",
    },
    hero: {
      overline: "ブランド向け · トレード会員",
      heading: "デザインごとに$2,500を支払うのをやめましょう。",
      headingEm: "$0から始める。",
      body: "会員資格でフルカタログ、AI搭載マーケティングツール、独立デザイナーとの直接調達がアンロックされます。デザインライセンスは別途——製造を選んだデザインのみお支払い。",
    },
    socialProof: [
      "48以上のプレエンジニアードデザイン",
      "6カ国のデザイナー",
      "AIキットは3分以内に生成",
      "1個目から利益",
    ],
    billing: {
      monthly: "月払い",
      annual: "年払い",
      savingActive: "約17%節約中",
      savingPrompt: "年払いで約17%節約",
    },
    tiers: {
      explorer: {
        name: "Discover",
        tagline: "可能性を探る",
        description: "カタログを閲覧、お気に入りを保存、200ウェルカムクレジットで初めてのAIマーケティングキットを生成——無料、クレジットカード不要。",
        features: [
          "フルカタログを閲覧——すべてのデザイナー、すべての作品",
          "デザインをショートリストに保存",
          "200ウェルカムStudio Credits（一回限り）",
          "2つのEssentials Kitを生成して品質を体験",
          "数量を選択——CADから配送まで私たちが対応",
        ],
        cta: "無料で始める",
      },
      professional: {
        name: "Source",
        tagline: "デザイナーへの直接アクセス",
        description: "フル調達アクセス。デザイナーとの直接関係。月1,500クレジット——15セットの完全マーケティングキットまたは150枚のクイックカタログ写真に十分。",
        mostPopular: "最も人気",
        features: [
          "Discoverのすべて、さらに：",
          "毎月1,500 Studio Credits",
          "デザイナーから直接調達——仲介なし",
          "プライベートメッセージでライセンス条件を交渉",
          "AIマーケティングキット：ライフスタイル写真、ルックブック、SNS素材——数分で完成",
          "Standard + Exclusiveライセンス層",
          "金属、宝石、スタイル、価格、在庫でフィルター",
        ],
        cta: "Sourceを始める",
      },
      atelier: {
        name: "Atelier",
        tagline: "あなたのプライベートデザイン工房",
        description: "Vaultライセンスによる完全な知的財産権の移転。専任プロダクションマネージャーがCADから配送まですべてを対応。月5,000クレジット。",
        features: [
          "Sourceのすべて、さらに：",
          "Vaultライセンス——完全IP + CADファイル移転",
          "毎月5,000 Studio Credits",
          "専任プロダクションマネージャー——あなたの単一連絡先",
          "優先サポート——直通回線、当日対応",
          "新デザイナーへの早期アクセス",
          "カスタム調達ブリーフ——必要なものを教えてください、私たちが見つけます",
          "マルチSKU注文のボリュームライセンス条件",
          "Cara AI——AIアシスタンスでオリジナルジュエリーをデザイン",
        ],
        cta: "Atelierを始める",
      },
      enterprise: {
        name: "Enterprise",
        tagline: "無制限にスケール",
        description: "小売チェーンや大規模ディストリビューター向け。カスタムクレジットボリューム、API統合、ホワイトグローブ製造管理、専任アカウントチーム。",
        customLabel: "カスタム",
        customSublabel: "ボリュームと要件に合わせてカスタマイズ",
        features: [
          "Atelierのすべて、さらに：",
          "カスタムStudio Creditボリューム——カタログ速度に合わせて",
          "APIアクセス——カタログ、キット、注文管理",
          "複数工場にわたるホワイトグローブ製造管理",
          "専任アカウントチーム、四半期ビジネスレビュー",
          "カスタムSLA、オンボーディング、トレーニング",
          "マルチシートチームアクセス、ロールベースの権限",
          "交渉済みライセンス条件とボリュームディスカウント",
          "優先製造キュー——あなたの注文が最優先で出荷",
        ],
        cta: "チームに相談する",
      },
    },
    priceDisplay: {
      free: "無料",
      freeSublabel: "クレジットカード不要",
      perMonth: "/月",
      saveBadge: "（約17%節約）",
      orAnnualOption: "または {amount}/年",
      billedAnnually: "年払い {amount}",
      licensesSeparate: "デザインライセンスは別途請求",
    },
    getStarted: "始める",
    studioCredits: {
      overline: "Studio Credits",
      heading: "固定コスト、毎回のアクション。サプライズなし。",
      body: "カタログ撮影からCaraとのデザイン相談まで、すべてのAIアクションは月間配分から固定数のクレジットを消費します。もっと必要？チャージパックは即座に利用可能で、期限切れなし。",
      link: "クレジット費用とチャージパックを見る →",
    },
    roi: {
      overline: "数字で見る",
      heading: "新SKUを発売する本当のコスト。",
      body: "従来の調達は隠れたコストと数ヶ月のリードタイムに利益を埋めます。Caratzonはパイプライン全体を圧縮します。",
      traditionalLabel: "従来の調達",
      caratzonLabel: "Caratzon",
      rows: [
        { metric: "市場投入時間", traditional: "4〜6ヶ月", caratzon: "3週間" },
        { metric: "R&D・CADモデリング", traditional: "$800〜$2,500+", caratzon: "$0——プレエンジニアード" },
        { metric: "実物サンプリング", traditional: "1回あたり$500+", caratzon: "$0——AIレンダリングプレビュー" },
        { metric: "マーケティング撮影", traditional: "キャンペーンあたり$2,000+", caratzon: "約$7（Studio Credits）" },
        { metric: "損益分岐点", traditional: "約50個販売", caratzon: "1個目" },
      ],
      note: "プレエンジニアードCADファイル。デジタルツインサンプリング。AI搭載撮影。Caratzonのすべてのデザインは1個目から利益が出ます。",
    },
    faq: {
      overline: "よくある質問",
      heading: "知っておくべきすべて。",
      items: [
        {
          q: "プラットフォーム料金とデザインライセンスにはそれぞれ何が含まれますか？",
          a: "会員資格にはカタログアクセス、AI搭載マーケティングツール（Studio Credits）、直接調達機能が含まれます。デザインライセンスは別途——製造を選んだデザインのみお支払い。会員資格はツールボックス、ライセンスは素材と考えてください。",
        },
        {
          q: "未使用のStudio Creditsはどうなりますか？",
          a: "月間クレジットは各請求サイクルの終了時に期限切れになります。これにより全員に公平な価格設定が維持されます。定期的にもっと必要な場合は、プランをアップグレードするかチャージパックを購入してください——チャージクレジットは期限切れなし。",
        },
        {
          q: "いつでもプランの変更やキャンセルはできますか？",
          a: "はい。即座にアップグレード、請求サイクル終了時にダウングレード。ロックイン契約なし、キャンセル料なし。年間プランは未使用月分の日割り返金でキャンセル可能。",
        },
        {
          q: "デザインライセンスには具体的に何が含まれますか？",
          a: "すべてのライセンスにはプレエンジニアードCADファイル（製造に直接ルーティング——ファイルを扱う必要なし）、選択した層の完全な商業権利（Standard、Exclusive、またはVault）、およびEssentials Kit（カタログ写真、仕様、SEOコピー）が含まれます。ライフスタイル撮影付きのCaratzon KitはStudio Creditsで生成されます。",
        },
        {
          q: "Vaultライセンス（IP移転）はどのように機能しますか？",
          a: "AtelierとEnterpriseプランで利用可能。Vaultはデザインの永久独占所有権を付与します——オリジナルCADファイルを含む。デザイナーは一回限りの買取料を受け取ります。Vault化されると、デザインは公開カタログから削除されます。あなたのものです。",
        },
        {
          q: "製造は自分で対応する必要がありますか？",
          a: "いいえ。すべての製造注文は審査済みのEPH製造ネットワークを通じてルーティングされます。鋳造、セッティング、品質管理、物流はエンドツーエンドで管理されます。ダッシュボードからマイルストーンを承認——残りは私たちが対応します。",
        },
      ],
    },
    bottomCta: {
      heading: "違う方法で調達する準備はできましたか？",
      body: "Discoverで無料スタート。準備ができたらアップグレード——コミットメントなし。",
      button: "カタログを閲覧",
      link: "カスタムプランが必要ですか？ご相談ください。",
    },
  },

  academy: {
    meta: {
      title: "アカデミー — Caratzon",
      description: "デザイナーとマイクロブランドのための、ジュエリーマニュファクチャリング・ブランドビルディング・インダストリートレンドに関するエキスパートガイド。",
    },
    hero: {
      title: "Caratzon Academy",
      subtitle: "CADからコマースまで — ジュエリーデザイナーとエマージングブランドのためのエキスパートナレッジ。",
    },
    categories: {
      all: "すべて",
      manufacturing: "マニュファクチャリング",
      business: "ビジネス",
      trends: "トレンド",
      wholesale: "ホールセール",
      brand: "ブランド",
      tech: "テクノロジー",
      operations: "オペレーション",
    },
    readingTime: "分で読了",
    featured: "フィーチャード",
    relatedArticles: "関連記事",
    backToAcademy: "← アカデミーに戻る",
    cta: {
      title: "あなたのデザインを形にしませんか？",
      description: "Caratzonは独立系デザイナーと認証済みマニュファクチャラーをつなぎ、シームレスなプロダクションを実現します。",
      button: "Caratzonで始める →",
    },
    rss: "RSSフィード",
    noArticles: "記事はまだありません。近日公開予定です。",
  },

  newsroom: {
    meta: {
      title: "Newsroom — Caratzon",
      description:
        "Latest news, press releases, and updates from Caratzon. Company announcements, product launches, partnerships, and industry insights.",
    },
    hero: {
      issueLabel: "Newsroom",
      title: "Latest from Caratzon",
      subtitle: "Company news, press releases, product updates, and industry insights.",
    },
    categories: {
      all: "All",
      company: "Company",
      product: "Product",
      partnership: "Partnership",
      industry: "Industry",
      press_release: "Press Release",
    },
    readingTime: "min read",
    featured: "Featured",
    relatedArticles: "Related Articles",
    backToNewsroom: "← Back to Newsroom",
    cta: {
      title: "Ready to bring your designs to life?",
      description:
        "Caratzon connects independent designers with certified manufacturers for seamless production.",
      button: "Start on Caratzon →",
    },
    noArticles: "No articles yet. Check back soon!",
    pressAssets: {
      meta: {
        title: "Press Assets — Caratzon Newsroom",
        description:
          "Brand logos, guidelines, and media resources for press and partners. Download Caratzon brand assets for editorial use.",
      },
      hero: {
        issueLabel: "Press Assets",
        title: "Press Assets",
        subtitle:
          "Brand resources for press, partners, and editorial use. Download logos and guidelines below.",
      },
      logos: {
        heading: "Brand Logos",
        primary: "Primary logo (light)",
        dark: "Primary logo (dark)",
        icon: "Icon only",
        stacked: "Stacked",
      },
      guidelines: {
        heading: "Brand Guidelines",
        colorPalette: "Color Palette",
        colorNotes:
          "Primary brand accent: Teal Sapphire (#005F6B). Deep India ink for text. Warm cream vellum for backgrounds. Gold leaf reserved for decorative use only.",
        typography: "Typography",
        typographyNotes:
          "Display: Cormorant Garamond, Cormorant SC. Body: Inter. Use display fonts for headlines and editorial accents; Inter for UI and body copy.",
      },
      contact: {
        heading: "Press Contact",
        description: "For media inquiries, press kits, and interview requests:",
        contactLink: "General inquiries →",
      },
    },
  },

  contentKit: {
    nav: "Caratzon Kits",
    meta: {
      title: "Caratzon Kits — Caratzon",
      description: "ジュエリーデザイン用のコンプリートCaratzon Kitを作成 — モデルフォトグラフィー、ルックブックショット、カタログビジュアル、SNSキャプション、エディトリアルストーリー。",
    },
    list: {
      title: "あなたのCaratzon Kits",
      subtitle: "デザインからマーケティングレディのモデルフォトグラフィー・ビジュアル・コピー・ルックブックを作成。",
      createNew: "新規Caratzon Kit",
      empty: "Caratzon Kitはまだありません。最初のKitを作成して始めましょう。",
      status: {
        draft: "ドラフト",
        generating: "生成中",
        ready: "レディ",
        failed: "失敗",
      },
    },
    wizard: {
      step1: "ソースを選択",
      step2: "ビジュアルを生成",
      step3: "コピーを生成",
      step4: "ルックブックを作成",
      step5: "パブリッシュ＆シェア",
      source: {
        title: "デザインソースを選択",
        fromCatalog: "カタログから",
        fromCatalogDesc: "マーケットプレイスでライセンスしたデザインを選択。",
        uploadNew: "イメージをアップロード",
        uploadNewDesc: "ご自身のジュエリーフォトをアップロード。",
        titleLabel: "ピースタイトル",
        descriptionLabel: "説明",
        next: "ビジュアルを生成",
      },
      visuals: {
        title: "生成されたビジュアル",
        subtitle: "AIエンハンスドのプロダクトショットとライフスタイルルックブックイメージ。",
        generating: "ビジュアルを生成中…",
        regenerate: "リジェネレート",
        acceptAll: "承認して次へ",
        catalogShot: "プロダクトショット",
        lookbookShot: "ライフスタイル",
      },
      copy: {
        title: "マーケティングコピー",
        subtitle: "AI生成のプロダクトディスクリプションとSNSキャプション。",
        generating: "コピーを作成中…",
        productDescription: "プロダクトディスクリプション",
        brandStory: "ブランドストーリー",
        socialCaptions: "SNSキャプション",
        regenerate: "コピーをリジェネレート",
        next: "ルックブックを作成",
      },
      lookbook: {
        title: "ルックブックプレビュー",
        subtitle: "ダウンロードレディのAIアセンブルドルックブック。",
        generating: "ルックブックをアセンブル中…",
        template: "テンプレートスタイル",
        regenerate: "別スタイルでリジェネレート",
        templates: {
          minimal: "ミニマル",
          editorial: "エディトリアル",
          bold: "ボールド",
          organic: "オーガニック",
        },
        next: "パブリッシュ＆シェア",
      },
      publish: {
        title: "パブリッシュ＆シェア",
        subtitle: "Caratzon Kitをダウンロード、またはDiscoveryにパブリッシュ。",
        download: "ダウンロード",
        downloadAll: "コンプリートKitをダウンロード",
        downloadImages: "イメージをダウンロード (ZIP)",
        downloadCopy: "コピーをダウンロード (TXT)",
        downloadPdf: "ルックブックをダウンロード (PDF)",
        publish: "Discoveryにパブリッシュ",
        publishDesc: "CaratzonでDiscoveryページをパブリックに公開。",
        slugLabel: "Discovery URL",
        categoryLabel: "カテゴリ",
        materialsLabel: "素材",
        keywordsLabel: "スタイルキーワード",
        heroLabel: "ヒーローイメージ",
        published: "パブリッシュしました！",
        viewDiscovery: "Discoveryページを表示",
      },
    },
    upsell: {
      title: "Studio Creditsが不足しています",
      body: "Sourceにアップグレードで毎月1,500 Studio Creditsを獲得 — Caratzon Kit 15個分に相当。またはクレジットパックで即時トップアップ。",
      cta: "プランを見る",
    },
  },

  concierge: {
    title: "Caratzon Concierge",
    subtitle: "B2Bジュエリーソーシングアシスタント",
    welcome: "ようこそ！デザイン、ライセンスティア、マニュファクチャリング、Caratzonに関するあらゆるご質問にお答えします。",
    inputPlaceholder: "デザイン、ライセンス、プライシングについて質問…",
    disclaimer: "AIによる回答です。内容が完全に正確でない場合があります。",
    quickActions: [
      "ライセンスの仕組みは？",
      "デザイナーとして参加するには？",
      "プライシングプランについて教えて",
      "担当者と話したい",
    ],
    leadForm: {
      title: "チームとつながる",
      description: "詳細をご共有ください。Caratzonチームが24時間以内にフォローアップいたします。",
      name: "お名前",
      email: "ビジネスメール",
      company: "会社名（任意）",
      message: "ご用件を簡単にご記入ください…",
      submit: "チームとつなげてください",
      successTitle: "接続完了",
      success: "Caratzonチームが24時間以内にご連絡いたします。引き続きこちらでチャットいただけます。",
    },
    handoffConfirm: {
      title: "ハンドオフをリクエストしました",
      description: "Caratzonチームにリクエスト内容を通知しました。担当者が間もなくご連絡いたします。引き続きこちらでチャットいただくか、trade@caratzon.com まで直接ご連絡ください。",
    },
  },

  inspire: {
    meta: {
      title: "Inspire — Caratzon",
      description: "世界中のデザイナーとブランドによる卓越したジュエリーデザインをエクスプロア。",
    },
    explore: {
      title: "Inspire",
      subtitle: "世界中のクリエイターによるジュエリーデザインをエクスプロア。",
      allCategories: "すべて",
      noResults: "このカテゴリにピースはありません。",
    },
    profile: {
      pieces: "ピース",
      totalViews: "トータルビュー",
    },
    detail: {
      by: "by",
      views: "ビュー",
      materials: "素材",
      share: "シェア",
      viewProfile: "プロフィールを表示",
      cta: {
        title: "あなたのInspireページを作成",
        body: "デザイナーとして参加し、AI生成のルックブック・エディトリアルストーリー・専用プロフィールで作品をショーケース。すべてStudioから。",
        button: "クリエイションを始める",
      },
    },
    saved: {
      title: "保存したピース",
      empty: "保存したピースはまだありません。",
      emptySubtitle: "Inspireでお気に入りを見つけましょう。",
      backToInspire: "Inspireに戻る",
    },
    creatorOnboarding: {
      meta: {
        title: "Inspireクリエイターとして参加 · Caratzon",
        description: "あなたのクラフト、ストーリー、ビジョンをお聞かせください — 世界に向けてあなたをご紹介します。",
      },
      header: "Inspire · クリエイターオンボーディング",
      stepOf: "ステップ {step} / {total}",
      back: "← 戻る",
      continue: "次へ →",
      steps: {
        profile: "プロフィール",
        styleTools: "スタイル＆ツール",
        creativeDna: "クリエイティブDNA",
        philosophy: "哲学",
        innerWorld: "インナーワールド",
        production: "プロダクション",
        review: "レビュー",
      },
      profile: {
        title: "デザイナープロフィール",
        subtitle: "バイヤーとPMがプラットフォームで目にする内容です。",
        firstName: "名 *",
        lastName: "姓 *",
        studioName: "Studio / ブランド名",
        studioPlaceholder: "例：Studio Noir、Aria Atelier",
        location: "所在地 / 都市",
        locationPlaceholder: "例：Paris, France",
        photo: "プロフィール写真",
        photoOptional: "（任意 — AIでエンハンス）",
        photoHint: "ヘッドショットまたはスナップ写真をアップロードしてください。AIが温かみのあるスタジオ照明とクリーンな背景でエンハンスします。",
        photoEnhancing: "AIで写真をエンハンス中…",
        photoSaved: "写真をエンハンスして保存しました ✓",
        photoChange: "変更",
        photoUpload: "アップロード",
      },
      style: {
        title: "あなたのエステティックとツール",
        subtitle: "適切なバイヤーオーディエンスとのマッチングに使用します。",
        aestheticLabel: "デザインのエステティックをどのように表現しますか？ *",
        aestheticHint: "該当するものをすべて選択",
        designStyleLabels: {
          "Minimalist": "ミニマリスト",
          "Vintage-inspired": "ヴィンテージ",
          "Bridal/Engagement": "ブライダル / エンゲージメント",
          "Men's": "メンズ",
          "Bold/Chunky": "ボールド / チャンキー",
          "Trend-driven Fashion": "トレンドファッション",
          "Everyday Fine": "エブリデイファイン",
          "Maximalist": "マキシマリスト",
        } as Record<string, string>,
        cadLabel: "主に使用するCADソフトウェアは？ *",
        cadHint: "該当するものをすべて選択",
        formatsLabel: "提供可能なファイルフォーマットは？",
        formatsHint: "該当するものをすべて選択",
      },
      creative: {
        title: "あなたのクリエイティブDNA",
        subtitle: "クラフトのルーツを理解するためにご回答ください。これらの回答がAIがバイヤーにあなたのストーリーを伝える方法を形作ります。",
        originLabel: "ジュエリーデザイナーになった経緯は？ *",
        originHint: "あなたの原点 — このクラフトに惹かれた理由は？ 幼い頃の記憶、メンター、転機？",
        originPlaceholder: "ジャイプールの祖母の工房で、祖母がシルクにシードパールを通すのを見て育ちました。光が一粒一粒のビーズに当たる様子が、私には魔法のように感じられました…",
        materialsLabel: "最もつながりを感じる素材は？",
        materialsHint: "共鳴するものをすべて選択",
        signatureMaterialLabels: {
          "Gold (yellow, rose, white)": "ゴールド（イエロー、ローズ、ホワイト）",
          "Platinum": "プラチナ",
          "Silver / Sterling": "シルバー / スターリング",
          "Titanium": "チタン",
          "Enamel": "エナメル",
          "Precious gemstones": "貴石",
          "Semi-precious stones": "半貴石",
          "Pearls": "パール",
          "Diamonds": "ダイヤモンド",
          "Wood / organic materials": "木材 / 天然素材",
          "Recycled metals": "リサイクルメタル",
          "Lab-grown stones": "ラボグロウンストーン",
          "Mixed media": "ミクストメディア",
        } as Record<string, string>,
        ritualsLabel: "クリエイティブな儀式を描写してください",
        ritualsHint: "プロセスはどのようなものですか？ まずスケッチしますか、直接CADに取りかかりますか、ワックスで作業しますか？ どこで作業しますか？",
        ritualsPlaceholder: "いつもテクスチャードペーパーに水彩スケッチから始めます。画面に触れる前に、重さと流れを感じる必要があります…",
        culturalLabel: "作品を形作る文化的・歴史的影響は？",
        culturalHint: "伝統、地域、時代、芸術運動 — あなたのビジュアルランゲージを支えるあらゆるもの。",
        culturalPlaceholder: "アールデコの幾何学、ムガル朝の花モチーフ、日本の侘び寂びの不完全さ…",
      },
      philosophy: {
        title: "デザイン哲学",
        subtitle: "これらの質問は、クラフトについての考え方 — あなたの作品をあなたらしくする緊張、信念、選択 — を明らかにします。",
        oneWordLabel: "デザイン哲学を一言で表すと？ *",
        oneWordPlaceholder: "例：Tension、Reverence、Defiance、Fluidity",
        feelingLabel: "あなたのジュエリーを身につけた人に、何を感じてほしいですか？ *",
        feelingHint: "見た目ではなく — そのピースが呼び起こすべき感情の状態は？",
        feelingPlaceholder: "秘密を抱えているような — 大切で完全に自分だけのもの。自己主張する必要のない静かな自信。",
        tensionLabel: "作品を定義するクリエイティブな緊張は？",
        tensionHint: "すべてのデザイナーはトレードオフを乗り越えます。装飾 vs. 抑制？ 伝統 vs. 変革？ 完璧 vs. 生々しさ？",
        tensionPlaceholder: "常に精密さと不完全さの間で引き裂かれています。すべてのラインに意図を持たせたいが、メタルが驚きを見せてくれる余地を残したい…",
        opinionLabel: "ジュエリーデザインについて、あなたが持つ不人気な意見は？",
        opinionHint: "業界の大多数が反対するであろう、あなたが信じていること。",
        opinionPlaceholder: "対称性は過大評価されていると思います。最も美しいピースには、生きているように感じさせる意図的な非対称性があります…",
      },
      innerWorld: {
        title: "あなたのインナーワールド",
        subtitle: "これらの深い質問は、ベンチの向こう側のあなたをAIが理解するのに役立ちます — デザイナーストーリーが本物のあなたらしく感じられるように。",
        inspirationLabel: "ジュエリー以外で、デザインのインスピレーションになっているものは？ *",
        inspirationHint: "建築、音楽、自然、食、映画、数学、都市、感情 — 何でも。",
        inspirationPlaceholder: "ブルータリストのコンクリートが午後の光を捉える様子。オウムガイの殻の数学的螺旋。日本の石庭の静寂…",
        emotionalLabel: "デザインが満たしてくれる感情的なニーズは？",
        emotionalHint: "なぜ創作を続けるのですか？ それがなければ何が欠けますか？",
        emotionalPlaceholder: "心が静まる唯一の時間です。デザインに没頭しているとき、ノイズが止まり、ピースと私だけになります…",
        legacyLabel: "20年後、あなたの作品群があなたについて何を語ってほしいですか？",
        legacyHint: "レガシービジョン — あなたが創造するすべてをつなぐ糸は何であるべきか？",
        legacyPlaceholder: "人が身につけるだけでなく、大切に保管するピースを作ったこと。誰かのストーリーの一部となり、価値のためではなく意味のために受け継がれるオブジェクト…",
        metaphorLabel: "デザイン実践が場所だとしたら、どんな場所に見えますか？",
        metaphorHint: "クリエイティブスペースのメタファー — 現実でも想像でも。",
        metaphorPlaceholder: "崖の端にあるガラス張りの工房。精密なツール、野生の眺め。中はすべて整然とし、外はすべて手つかず…",
      },
      production: {
        title: "プロダクション準備",
        subtitle: "マニュファクチャラーには、物理的生産に最適化されたCADファイルが必要です — 石留めの厚さ、メタルウェイト、収縮公差。",
        cadOptimisedLabel: "CADファイルは物理製造に完全に最適化されていますか？",
        optionYes: "はい — 製造に完全に最適化されています",
        optionMostly: "ほぼ — 微調整が必要な場合があります",
        optionNo: "いいえ — レンダー/ビジュアライゼーション用にのみデザインしています",
        optionHelp: "ファイルの最適化にサポートが必要です",
        portfolioLabel: "ポートフォリオ / ウェブサイト",
        portfolioPlaceholder: "https://yourportfolio.com",
        socialLabel: "ソーシャルプロフィール",
        socialOptional: "（任意 — Inspireページに表示）",
        instagramPlaceholder: "@yourstudio または https://instagram.com/yourstudio",
        pinterestPlaceholder: "@yourstudio または https://pinterest.com/yourstudio",
        tiktokPlaceholder: "@yourstudio または https://tiktok.com/@yourstudio",
        sampleUploadsTitle: "サンプルアップロード",
        sampleUploadsBody: "プロフィール完成後、StudioダッシュボードからCADレンダーと完成品写真を直接アップロードできます。",
      },
      review: {
        title: "プロフィールを確認",
        subtitle: "問題なければ、承認後にStudio設定から更新できます。",
        aiEnhanced: "AIエンハンスドポートレート",
        labels: {
          name: "名前",
          studio: "Studio",
          location: "所在地",
          aesthetic: "エステティック",
          cadSoftware: "CADソフトウェア",
          fileFormats: "ファイルフォーマット",
          productionReady: "プロダクション準備",
          portfolio: "ポートフォリオ",
          instagram: "Instagram",
          pinterest: "Pinterest",
          tiktok: "TikTok",
        },
        creativeProfile: "クリエイティブプロフィール",
        creativeLabels: {
          originStory: "原点ストーリー",
          materials: "素材",
          philosophy: "哲学",
          wearerFeels: "装着者の感情",
          inspiration: "インスピレーション",
          legacy: "レガシー",
        },
        storyGeneration: {
          title: "デザイナーストーリーを生成",
          subtitle: "AIがアンケート回答から魅力的なナラティブを作成 — Inspireページで公開可能な状態に。",
          button: "ストーリーを生成",
          loading: "ナラティブを執筆中…",
          error: "ストーリー生成に失敗しました",
          tryAgain: "再試行",
          refineLater: "承認後、Studioダッシュボードからこのストーリーをリファインできます。",
        },
        terms: {
          prefix: "上記の情報が正確であることを確認し、Caratzonの",
          termsLink: "デザイナー利用規約",
          and: "および",
          privacyLink: "プライバシーポリシーに同意します",
        },
        submit: "申請を送信 →",
        submitting: "送信中…",
      },
      errors: {
        nameRequired: "名と姓をご入力ください。",
        agreeRequired: "続行するにはデザイナー利用規約への同意が必要です。",
        submissionFailed: "申請の送信中にエラーが発生しました。もう一度お試しください。",
      },
      pending: {
        meta: {
          title: "申請審査中 · Caratzon",
          description: "デザイナー申請をチームで審査しています。",
        },
        overline: "プライベートベータ",
        thankYou: "{name}さん、ありがとうございます",
        thankYouGeneric: "ありがとうございます",
        submitted: "申請は正常に送信されました。Caratzonは現在",
        privateBeta: "プライベートベータ",
        submittedSuffix: "のため、すべてのデザイナー申請をチームが個別に審査しています。",
        emailNotice: "アカウント承認後、メールでお知らせします。通常1〜2営業日かかります。",
        backToHome: "ホームに戻る",
        exploreAcademy: "アカデミーを探索 →",
        rejected: {
          overline: "申請更新",
          heading: "このたびは申請をご承認できませんでした",
          body: "Caratzonへのご関心をいただきありがとうございます。現時点では申請をご承認できません。誤りと思われる場合や追加情報をご提供いただける場合は、チームまでご連絡ください。",
          feedbackLabel: "チームからのフィードバック",
          contactUs: "お問い合わせ",
          reapply: "再申請",
          reapplying: "送信中…",
        },
      },
    },
  },

  caraChat: {
    empty: {
      title: "Cara をご紹介",
      description: "AI デザインアシスタント — ジュエリーマスターとメカニカルエンジニアの融合。ビジョンを伝え、スケッチをアップロード、またはインスピレーション画像をドロップして始めましょう。",
      sketchToConcept: "スケッチ → コンセプト",
      photoToDesign: "写真 → デザイン",
      ideaToRender: "アイデア → レンダー",
    },
    placeholder: {
      initial: "ビジョンを伝え、スケッチをアップロード、または画像をドロップ…",
      direction: "Cara にデザインの方向性を伝えましょう — 素材、スタイル、時代…",
      adjust: "Cara にデザインの調整や構造分析を依頼…",
      finalize: "仕上げの準備はできましたか？カタログレンダーと部品表を生成しましょう。",
    },
    dragOverlay: "スケッチまたは参考画像をドロップ",
    scrollPill: "↓ 新しいメッセージ",
    sketchFallback: "スケッチ/参考画像です。分析してください。",
    error: "エラーが発生しました。もう一度お試しください。",
    regenerate: "再生成",
    suggestions: {
      custom: "その他…",
      customPlaceholder: "回答を入力…",
      send: "送信",
    },
    editMessage: "メッセージを編集",
    editSend: "送信",
    editCancel: "キャンセル",
    download: "ダウンロード",
    copyMessage: "メッセージをコピー",
    justNow: "たった今",
    minutesAgo: "{n}分前",
    toolLabels: {
      generate_mood_board: "ムードボード",
      generate_concept_sketch: "コンセプトスケッチ",
      generate_design_render: "デザインレンダー",
      adjust_design: "調整レンダー",
      generate_catalog_render: "カタログレンダー",
      render_from_sketch: "スケッチコンセプト",
      analyze_sketch: "スケッチ分析",
      analyze_inspiration: "インスピレーション分析",
      reference_lookup: "リファレンス検索",
      structural_analysis: "構造分析",
      calculate_bom: "部品表",
      material_recommendation: "素材分析",
      generate_turntable_video: "ターンテーブル動画",
      generate_lookbook_image: "ルックブック画像",
      present_design_specs: "デザイン仕様",
      finalize_design: "デザイン確定",
      share_to_gallery: "ギャラリーへ共有",
    },
    toolLoading: {
      rendering: "レンダリング中…",
      sketchingConcept: "コンセプトをスケッチ中…",
      analyzingSketch: "スケッチを分析中…",
      analyzingInspiration: "インスピレーションを分析中…",
      lookingUpReference: "リファレンスデータを検索中…",
      generatingVideo: "動画を生成中 — 最大1分かかります…",
      stylingLookbook: "ルックブック撮影中…",
      structuralAnalysis: "製造可能性シミュレーション実行中…",
      materialCheck: "素材の互換性を確認中…",
      calculatingBom: "部品表を計算中…",
      sharingToGallery: "ギャラリーへ共有中…",
      preparingSpecs: "仕様を準備中…",
      finalizingDesign: "デザインを確定中…",
      processing: "処理中…",
    },
    toolCards: {
      moodBoard: "ムードボード",
      conceptSketch: "コンセプトスケッチ",
      refinedSketch: "精密スケッチ",
      turntablePreview: "ターンテーブルプレビュー",
      sketchAnalysis: "スケッチ分析",
      inspirationAnalysis: "インスピレーション分析",
      structuralAnalysis: "構造分析",
      billOfMaterials: "部品表",
      materialAnalysis: "素材分析",
      designFinalized: "デザイン確定",
      sharedToGallery: "ギャラリーに共有済み",
      errorFallback: "エラーが発生しました。",
      designRender: "デザインレンダー",
      updatedRender: "更新レンダー",
      catalogRender: "カタログレンダー",
      conceptFromSketch: "スケッチからのコンセプト",
      lookbookLabel: "ルックブック",
      saveToStudio: "Studio に保存",
      savedOpenStudio: "保存済み — Studio を開く",
      submitBrief: "Submit Design Brief",
      briefSubmitted: "Brief submitted — View Orders",
      designTitlePlaceholder: "デザインタイトル…",
      saving: "保存中…",
      save: "保存",
      cancel: "キャンセル",
      structural: {
        manufacturabilityReport: "製造可能性レポート",
        areasAnalyzed: "{n} 箇所を分析",
        areasAnalyzedPlural: "{n} 箇所を分析",
        issuesFound: "問題あり",
        warnings: "警告",
        allClear: "問題なし",
        pass: "合格",
        warning: "警告",
        warningPlural: "警告",
        critical: "重大",
        recommendationLabel: "推奨：",
        addressCritical: "鋳造前に重大な問題に対処してください。",
        reviewWarnings: "上記の警告を確認してください — 調整により製造可能です。",
      },
      bom: {
        costBreakdown: "コスト内訳",
        lineItems: "{n} 品目",
        lineItemsPlural: "{n} 品目",
        item: "品目",
        qty: "数量",
        estCost: "推定コスト",
        laborSetting: "工賃・石留め",
        totalEstimate: "推定合計",
      },
      material: {
        compatibilityCheck: "互換性チェック",
        compatible: "互換あり",
        concerns: "懸念あり",
        concernsLabel: "懸念事項",
        recommendationsLabel: "推奨事項",
        allCompatible: "すべての素材が生産に使用可能です。",
      },
      sketch: {
        sketchInterpretation: "スケッチ解釈",
        needsInput: "入力が必要",
        stones: "宝石",
        filigree: "フィリグリー",
        engraving: "彫刻",
        designNotes: "デザインノート",
        needsClarification: "確認事項",
      },
      inspiration: {
        inspirationBreakdown: "インスピレーション分析",
        colorPalette: "カラーパレット",
        motifs: "モチーフ",
        textures: "テクスチャ",
        suggestedFinishes: "推奨仕上げ",
        suggestedForms: "推奨ジュエリー形態",
      },
      designSpecs: {
        weight: "重量",
        stones: "宝石",
        stoneSingular: "宝石",
        finish: "仕上げ",
        stonesLabel: "宝石",
        dimensions: "寸法",
        manufacturable: "製造可能",
        manufacturabilityConcerns: "製造可能性の懸念",
      },
      finalize: {
        productionReady: "量産可能",
        metal: "金属",
        stones: "宝石",
        stoneSingular: "宝石",
        estRetail: "推定小売価格",
        cadHandoff: "CAD引き渡し・鋳造・見積もりに対応",
      },
      gallery: {
        nowInGallery: "ギャラリーに追加済み",
        storyGenerating: "デザインストーリーを生成中 — ギャラリータブで確認できます。",
      },
      reference: {
        title: "リファレンスデータ",
        casting: "鋳造仕様",
        metals: "金属特性",
        stones: "宝石耐久性",
        settings: "セッティング互換性",
      },
    },
    starters: [
      { label: "ソリテールリング", text: "18Kローズゴールドに1ctオーバルダイヤモンドのモダンなソリテール婚約指輪をデザインして" },
      { label: "アールデコカクテルリング", text: "エメラルドとオニキスを使ったアールデコ幾何学のボールドなカクテルリングを作って" },
      { label: "テニスブレスレット", text: "プラチナにサファイアとダイヤモンドを交互に配したミニマリストテニスブレスレットをデザインして" },
    ],
    buyerOverrides: {
      empty: {
        title: "Design with Cara",
        description: "Describe the jewelry you're looking for — style, materials, occasion — and Cara will bring your vision to life with production-ready renders.",
      },
      placeholder: {
        initial: "Describe the jewelry you're looking for — style, materials, occasion…",
        direction: "Tell Cara more about your preferences — materials, budget, quantity…",
        adjust: "Ask Cara to adjust the design, or explore different variations…",
        finalize: "Happy with the design? Submit it as a design brief for production.",
      },
      starters: [
        { label: "Custom engagement ring", text: "I'm looking for a custom engagement ring — oval diamond, modern setting, rose gold" },
        { label: "Branded collection piece", text: "I need a signature pendant for my brand — minimalist, 14k gold, under $200 retail" },
        { label: "Wedding band set", text: "Design a matching his-and-hers wedding band set in platinum with subtle detailing" },
      ],
    },
  },

  ai: {
    meta: {
      title: "Cara AI — ジュエリーエンジニアリングインテリジェンス · Caratzon",
      description: "Caraは工場フロアのために設計するジュエリーエンジニアリングAIです。収縮補正、構造解析、部品表、製造準備済みコンセプト——ファンタジーレンダリングではありません。",
      socialDescription: "実際の製造のためにエンジニアリングするAI。収縮、公差、鋳造力学、着用性——すべてのコンセプトが製造準備済み。",
    },
    hero: {
      headingLine1: "生成画像ツールではありません。",
      headingLine2: "ジュエリーエンジニアリングAI。",
      ctaDemo: "Cara AIを試す — ライブデモ",
      ctaCredits: "クレジット費用を見る",
    },
    pillars: {
      label: "エンジニアリング制約",
      headingLine1: "すべてのコンセプトはストレステスト済み",
      headingLine2: "画面を離れる前に。",
    },
    capabilities: {
      label: "機能",
      headingLine1: "ナプキンスケッチから",
      headingLine2: "製造準備済みブループリントへ。",
    },
    whatYouCanAsk: {
      label: "何を聞けるか",
      heading: "会話であり、プロンプトボックスではない。",
      groups: [
        {
          title: "デザイン相談",
          prompts: [
            "「このスケッチの製造可能性を分析して」",
            "「18Kホワイトゴールドの最小壁厚は？」",
            "「このヘイローセッティングは日常使用に耐えられる？」",
          ],
        },
        {
          title: "材料科学",
          prompts: [
            "「このバンドプロファイルでプラチナ950と18Kを比較して」",
            "「0.8mmプロングにはどの合金を使うべき？」",
            "「14Kイエローのロストワックス鋳造の収縮率は？」",
          ],
        },
        {
          title: "ビジュアル生成",
          prompts: [
            "「ローズゴールドとパヴェバンドでこのコンセプトをレンダリング」",
            "「アールデコ婚約指輪のムードボードを生成」",
            "「このデザインの360°ターンテーブル動画を作成」",
          ],
        },
        {
          title: "製造計画",
          prompts: [
            "「このリングの部品表を生成」",
            "「18K + VS1ダイヤモンドの製造コストを見積もり」",
            "「50個ロットの製造タイムラインは？」",
          ],
        },
      ],
    },
    creditsTeaser: {
      label: "Studio Credits",
      heading: "透明で固定コストのAI。",
      body: "すべてのCaraアクションには固定クレジットコスト——メッセージ5クレジット、画像レンダリング15クレジット、360°動画25クレジット。トークン計測なし、サプライズなし。",
      link: "すべてのクレジット費用とチャージパックを見る →",
    },
    finalCta: {
      heading: "ご自身でお確かめください。",
      body: "ライブデモを試す——アカウント不要。スケッチをアップロードし、質問して、Caraが製造準備済みコンセプトをエンジニアリングするのをご覧ください。",
      ctaDemo: "Cara AIを試す — ライブデモ",
      ctaPricing: "料金を見る",
    },
  },

  designerAi: {
    meta: {
      title: "Cara AI デザイナー向け — Caratzon",
      description: "CADの製造可能性を検証し、ポートフォリオレンダー、360°動画、ルックブック撮影を生成 — すべてCara AIが実現。デザインに集中し、エンジニアリングはCaraにお任せください。",
      socialDescription: "ジュエリーデザイナーのためのAIコパイロット。CAD検証、レンダー生成、ポートフォリオ構築 — 初日から量産対応。",
    },
    hero: {
      overline: "Cara AI · デザイナー向け",
      headingLine1: "自由にデザインを。",
      headingLine2: "エンジニアリングはCaraが。",
      body: "CaraはあなたのAIコパイロット — マスタージュエラーとメカニカルエンジニアを兼ね備えた存在です。CADの製造可能性を検証し、スタジオグレードのレンダーを生成し、バイヤーが思わず連絡したくなるポートフォリオを構築。あなたはクリエイティブワークに集中するだけ。",
      ctaDemo: "Cara AIを試す — ライブデモ",
      ctaStudio: "Studioを開く",
    },
    pillars: {
      label: "Caraができること",
      headingLine1: "CADファイルから",
      headingLine2: "量産対応ポートフォリオへ。",
      items: [
        {
          stat: "CAD → レンダー",
          label: "ポートフォリオ生成",
          body: ".3DMまたは.STLをアップロードすると、Caraがスタジオグレードの商品写真、ライフスタイルレンダー、360°ターンテーブル動画を生成 — 以前は1点あたり数千ドルかかっていたビジュアル素材です。",
        },
        {
          stat: "±0.15mm",
          label: "製造可能性チェック",
          body: "Caraが実際の鋳造公差に基づいてデザインを分析 — 壁厚、収縮補正、プロング強度、エッジR — バイヤーの目に触れる前に問題を検出します。",
        },
        {
          stat: "自動BOM",
          label: "部品表",
          body: "即座に正確な部品表を取得 — 金属重量、石数、合金別コスト — 自信を持って価格設定でき、バイヤーには透明な生産見積もりが表示されます。",
        },
        {
          stat: "あなたの物語",
          label: "AIストーリーテリング",
          body: "Caraが各作品とコレクションのエディトリアルナラティブを執筆。テンプレートコピーではなく、あなたのデザイン哲学、素材、クリエイティブな意図から紡ぎ出すストーリーです。",
        },
      ],
    },
    capabilities: {
      label: "デザイナー向け機能",
      headingLine1: "ファイルからフィーチャーまで",
      headingLine2: "必要なすべてがここに。",
      items: [
        { label: "CAD検証", detail: "EPH製造公差に基づく構造分析 — 壁厚、アンダーカット、抜き勾配" },
        { label: "プロダクトレンダー", detail: "複数アングル、メタル、ストーン構成でのスタジオクオリティ商品写真" },
        { label: "360°ターンテーブル動画", detail: "バイヤーがプレゼンや提案書に埋め込めるアニメーションターンテーブルプレビュー" },
        { label: "ルックブック撮影", detail: "ブランドの美学に合わせたAI生成のライフスタイル＆モデル撮影" },
        { label: "コレクションナラティブ", detail: "デザインをコレクションにまとめ、Caraが全作品を通じた統一エディトリアルストーリーを執筆" },
        { label: "マテリアルインテリジェンス", detail: "10K〜24Kゴールド、925シルバー、950プラチナの合金別ガイダンス — 収縮率、硬度、仕上げ" },
      ],
    },
    workflow: {
      label: "Caraとのワークフロー",
      heading: "アップロード。検証。公開。",
      steps: [
        {
          title: "CADをアップロード",
          body: ".3DM、.STL、または.STEPファイルをStudioにドロップ。Caraがジオメトリを読み取り、即座に分析を開始します。",
        },
        {
          title: "レビュー＆改善",
          body: "Caraが製造可能性の問題を検出し、修正を提案し、完全な部品表を生成。Caraとチャットで反復 — 合金、公差、代替セッティングについて質問できます。",
        },
        {
          title: "ポートフォリオを生成",
          body: "ワンクリックでプロダクトレンダー、ライフスタイルショット、360°動画、エディトリアルストーリーを生成。あなたのデザインが生ファイルからバイヤー向けショーケースに変わります。",
        },
        {
          title: "Inspire＆カタログに公開",
          body: "検証済み・レンダー済みのデザインをInspireクリエイターページとトレードカタログにワンステップで公開。バイヤーがあなたの作品を発見する時、ビジュアルとナラティブはすでに整っています — すぐにライセンス可能です。",
        },
      ],
    },
    closing: "Caraはあなたの創造性を置き換えるものではありません — デザインとそれを見るべきバイヤーの間にあるすべての障壁を取り除きます。フォトグラファー不要。コピーライター不要。工場との連絡不要。あなたのビジョンだけが、量産検証済みで美しくプレゼンテーションされます。",
    creditsTeaser: {
      label: "Studioクレジット",
      heading: "固定コストAI。サプライズなし。",
      body: "すべてのCaraアクションに透明なクレジットコスト — メッセージ5クレジット、レンダー15クレジット、360°動画25クレジット。クレジットはプランに含まれ、いつでもチャージ可能です。",
      link: "クレジット費用を見る →",
    },
    finalCta: {
      heading: "あなたのデザインは見られるべきです。",
      body: "最初のCADをアップロードし、Caraに検証・レンダーさせ、Inspireに公開 — すべて5分以内。",
      ctaDemo: "Cara AIを試す — ライブデモ",
      ctaStudio: "Studioを開く",
    },
  },

  aiCredits: {
    meta: {
      title: "Studio Credits — Caratzon",
      description: "CaratzonのStudio Creditsの仕組み——フォトキット、デザイン相談などの固定コストAIアクション。画像ごとの課金なし。",
      socialDescription: "フォトキット、デザイン相談などの固定コストAIアクション。",
    },
    hero: {
      label: "Studio Credits",
      heading: "透明で固定コストのAI。",
      body: "CaratzonのすべてのAI搭載アクションは固定数のStudio Creditsを消費します。画像ごとの課金なし、トークン計測なし、サプライズなし。",
    },
    howItWorks: {
      label: "仕組み",
      heading: "獲得、使用、チャージ。",
      steps: [
        { step: "01", title: "クレジットを獲得", body: "有料プランには月間クレジット配分が含まれます。Explorerアカウントは200ウェルカムクレジットで試用。" },
        { step: "02", title: "任意のアクションに使用", body: "フォトキット、ルックブック、Cara AI相談——各アクションには事前に表示される固定クレジットコスト。" },
        { step: "03", title: "もっと必要な時にチャージ", body: "クレジットパックを即座に購入。チャージクレジットは期限切れなし——サブスクリプションクレジットは各請求サイクルでリセット。" },
      ],
    },
    photoStudio: {
      label: "Photo Studio",
      heading: "製造準備済み素材。",
      body: "デザインをアップロードして、カタログ品質の写真、ラインシート、マーケティングコピーを取得——すべてAI生成、数分で完了。",
    },
    caraAi: {
      label: "Cara AI",
      heading: "あなたのデザインエンジニアリングパートナー。",
      body: "Caraは冶金学、宝石セッティング、構造的完全性、製造制約を理解するAIジュエリーエンジニアです。材料科学からBOM見積もりまで何でも聞いてください。",
      note: "テキストメッセージ（5クレジット）は送信時に課金。画像・動画ツールはAIが呼び出した時に課金——実行前にコストが表示されます。典型的な10メッセージセッション＋数回のレンダリングで約100〜150クレジット使用。",
    },
    monthlyAllowances: {
      label: "月間配分",
      heading: "プランに含まれるクレジット。",
      tableHeaders: ["プラン", "月間クレジット", "ウェルカムクレジット", "価格"],
      rows: [
        { plan: "Discover", monthly: "—", welcome: "200", price: "無料" },
        { plan: "Source", monthly: "1,500", welcome: "—", price: "$149/月" },
        { plan: "Atelier", monthly: "5,000", welcome: "—", price: "$399/月" },
        { plan: "Enterprise", monthly: "カスタム", welcome: "—", price: "カスタム" },
      ],
      note: "サブスクリプションクレジットは各請求サイクルでリセット——未使用クレジットは繰り越されません。チャージクレジットは期限切れなし。",
    },
    topUpPacks: {
      label: "チャージパック",
      heading: "追加購入、永久保持。",
      body: "大型コレクションを発売？クレジットを即座に購入——期限切れなし。",
      bestValue: "最もお得",
      creditsLabel: "クレジット",
      perCredit: "¢/クレジット",
      buyPrefix: "購入",
      buySuffix: "クレジット",
      note: "サブスクリプションが常に最もお得——サブスクリプションクレジットはチャージパックよりクレジットあたりのコストが低い。",
      compareLink: "プランを比較",
    },
    faq: {
      label: "よくある質問",
      heading: "クレジット、詳しく解説。",
      items: [
        { q: "Caraとの会話中にクレジットが切れたらどうなりますか？", a: "テキストメッセージは送信前にチェック——チャージの案内が表示されます。画像・動画ツールは生成前にチェックするので、高額なアクションを実行する前にAIがクレジット不足を知らせます。" },
        { q: "未使用のサブスクリプションクレジットは繰り越されますか？", a: "いいえ。サブスクリプションクレジットは各請求サイクルの開始時にリセットされます。定期的にもっと必要な場合は、プランのアップグレードまたはチャージパックの購入をご検討ください——チャージクレジットは期限切れなし。" },
        { q: "1つのCaraメッセージが5クレジット以上かかることはありますか？", a: "はい。基本メッセージは5クレジットですが、Caraが返答で画像（各15クレジット）や動画（各25クレジット）を生成すると、段階的に課金されます。典型的なデザイン相談＋2〜3回のレンダリングで約50〜70クレジット。" },
        { q: "管理者はクレジットを課金されますか？", a: "いいえ。管理者アカウントは内部テストと運用のためクレジット課金が免除されます。" },
        { q: "Essentials KitとCaratzon Kitの違いは何ですか？", a: "Essentials Kit（10クレジット）はカタログ品質の写真、仕様、SEOコピーを生成。Caratzon Kit（100クレジット）はEssentialsのすべてに加え、ライフスタイル撮影、エディトリアル画像、SNS素材を含む完全なルックブック。" },
      ],
    },
    actions: {
      photoStudio: [
        { action: "Essentials Kit", detail: "カタログ写真、仕様、SEOコピー" },
        { action: "Caratzon Kit", detail: "フルフォトスタジオ——ライフスタイル撮影、ラインシート、SNS素材" },
        { action: "写真再生成", detail: "気に入らなかった1枚の写真を再生成" },
        { action: "ルックブックPDF", detail: "ブランド卸売ラインシート" },
      ],
      caraAi: [
        { action: "メッセージ", detail: "スケッチ分析、Q&A、材料科学、構造レビュー、デザイン相談" },
        { action: "スケッチ", detail: "テキスト説明からのクイックコンセプトスケッチ" },
        { action: "画像レンダリング", detail: "忠実なスケッチからコンセプトレンダリング、ムードボード、カタログ写真、デザイン調整" },
        { action: "ルックブック画像", detail: "プレゼンテーション用のエディトリアルルックブック画像" },
        { action: "360°動画", detail: "あらゆる角度からデザインを見せるターンテーブル動画" },
      ],
    },
  },

  demo: {
    meta: {
      title: "Cara AI デモ · Caratzon",
      description: "Caraをお試しください——工場と人の手のためにデザインするジュエリーエンジニアリングAI。収縮率、公差、鋳造メカニクス、装着感——すべてのコンセプトが生産可能。ライブデモ。",
    },
    splash: {
      eyebrow: "ジュエリーエンジニアリングAI",
      heading: "Cara のご紹介",
      subheading: "工場が製造でき、お客様が着けたくなるジュエリーを設計するエンジニアリングAI——最初のスケッチから。",
      cta: "デザインを始める",
      enterHint: "{key} を押して開始",
      promptDivider: "またはプロンプトをお試しください",
      signIn: "ログイン",
      noAccount: "アカウント不要",
      notSaved: "会話は保存されません",
      fullAccess: "フルアクセスはこちら →",
      namePlaceholder: "お名前（ギャラリーに表示）",
      nameHint: "作品のクレジットに使用します",
    },
    prompts: [
      { label: "婚約指輪", text: "1ct オーバルダイヤモンド、18K ローズゴールドのモダンなソリティア婚約指輪をデザイン" },
      { label: "アールデコ カクテルリング", text: "エメラルドとオニキスを使った大胆なアールデコ幾何学カクテルリングを作成" },
      { label: "テニスブレスレット", text: "サファイアとダイヤモンドを交互に配置したミニマルなプラチナテニスブレスレットをデザイン" },
      { label: "スカルプチャーカフ", text: "有機的な流線形の彫刻ゴールドカフ、宝石なし、純粋な金属加工" },
    ],
    capabilities: [
      { label: "スケッチから生産設計図", desc: "手描きスケッチをアップロード — Caraが工場向けにエンジニアリング" },
      { label: "鋳造・収縮分析", desc: "金属固有の収縮補正、壁厚バリデーション" },
      { label: "ストーントレランスマッピング", desc: "爪配置、座深、ガードルクリアランス — エンジニアリング済み" },
      { label: "装着感・快適性", desc: "バンドプロファイル、重量バランス、エッジ半径 — 終日装着を想定して設計" },
    ],
    header: {
      brandLabel: "Cara AI",
      tabs: { create: "作成", gallery: "ギャラリー" },
      back: "← 戻る",
      fullAccess: "フルアクセスを取得",
    },
    gallery: {
      loading: "ギャラリーを読み込み中…",
      emptyTitle: "まだデザインがありません",
      emptyBody: "最初の作品を作りましょう。デモセッション中に生成されたデザインがここに表示されます。",
      emptyAction: "最初のデザインを作成",
      sectionTitle: "このイベントで作成",
      countSingular: "デモ訪問者が生成した {count} 件のデザイン",
      countPlural: "デモ訪問者が生成した {count} 件のデザイン",
      createYours: "あなたも作成",
      createdWith: "Cara AI で作成",
      generating: "ストーリーを生成中…",
      viewStory: "ストーリーを見る",
      toolLabels: {
        render: "AI レンダー",
        mood_board: "ムードボード",
        catalog_render: "カタログレンダー",
      },
      fallbackTool: "レンダー",
      timeAgo: {
        justNow: "たった今",
        minutes: "{n}分前",
        hours: "{n}時間前",
        days: "{n}日前",
      },
    },
    story: {
      backToGallery: "← ギャラリーに戻る",
      fromSketch: "スケッチから",
      theSketch: "スケッチ",
      sketchCaption: "{name} のオリジナルスケッチ",
      theDetails: "デザイン詳細",
      detailType: "タイプ",
      detailMetal: "金属",
      detailStyle: "スタイル",
      detailStones: "宝石",
      detailFinish: "仕上げ",
      detailWeight: "重量",
      detailPrice: "推定価格",
      structuralAnalysis: "構造分析",
      theStory: "ストーリー",
      showcase: "ショーケース",
      designJourney: "デザインの軌跡",
      theConversation: "デザインの対話",
      moreMessages: "会話にはさらに {n} 件のメッセージがあります",
      createdBy: "クリエイター",
      createdWith: "{event}で Cara AI を使用して作成",
      eventName: "ライブデモ",
      tryIt: "Cara を試す →",
      artifactLabels: {
        render: "デザインレンダー",
        catalog_render: "カタログレンダー",
        concept_sketch: "コンセプトスケッチ",
        mood_board: "ムードボード",
        structural_analysis: "構造分析",
        material_recommendation: "素材分析",
        bom: "部品表",
        sketch_analysis: "スケッチ分析",
        lookbook: "ルックブック",
        video: "ターンテーブル動画",
        inspiration: "インスピレーション分析",
        design_specs: "デザイン仕様",
        finalize_design: "最終デザイン",
        gallery_share: "ギャラリー共有",
      },
    },
    brands: {
      splash: {
        eyebrow: "ブランド向けデザインAI",
        subheading: "ビジョンを伝えてください。レンダリングでご確認。そのまま量産へ。",
        cta: "体験を始める",
        namePlaceholder: "お名前またはブランド名",
        nameHint: "パーソナライズされた体験のために",
        fullAccess: "トレードアカウントを開設 →",
      },
      prompts: [
        { label: "テニスブレスレット", text: "春コレクション向けにこのテニスブレスレットをローズゴールドでカスタマイズして" },
        { label: "シグネチャーペンダント", text: "ブランドの幾何学モチーフでシグネチャーペンダントを作って — ミニマリスト、14K金" },
        { label: "ウェディングバンド", text: "3つの価格帯でミニマリストウェディングバンドセットのオプションを見せて" },
        { label: "スケッチから量産へ", text: "カフのスケッチがあります — 量産可能にできますか？" },
      ],
      capabilities: [
        { label: "カスタマイズプレビュー", desc: "フォトリアルなレンダリングでデザインビジョンを確認" },
        { label: "素材＆仕上げオプション", desc: "金属、宝石、仕上げを並べて比較" },
        { label: "サンプル価格", desc: "試作・小ロット生産の即時見積もり" },
        { label: "生産タイムライン", desc: "コンセプトから納品まで — 製造パス全体を確認" },
      ],
      header: {
        fullAccess: "トレードアカウント開設",
      },
    },
  },

  // ─── Production Dashboard ─────────────────────────────────────────────────
  productionDashboard: {
    title: "生産ダッシュボード",
    tabs: {
      portfolio: "ポートフォリオ",
      board: "ボード",
    },
    zoom: "ズーム",
    day: "日",
    week: "週",
    month: "月",
    search: "検索...",
    searchPlaceholder: "プラン、デザイン、製造業者を検索...",
    keyboardShortcuts: "キーボードショートカット",
    groupBy: "グループ分け",
    status: "ステータス",
    phase: "フェーズ",
    dragDisabledInPhase: "フェーズビューではドラッグ無効",
    backToPortfolio: "ポートフォリオ",
    subOrders: "サブオーダー",
    unassigned: "未割当",
    noItems: "項目なし",
    densityCompact: "コンパクト表示",
    densityComfortable: "ゆとり表示",

    empty: {
      portfolioTitle: "進行中の生産はありません",
      portfolioDescription: "生産プランナーで作成されたプランが承認されるとここに表示されます。",
      portfolioLink: "生産プランナーを開く",
      boardTitle: "サブオーダーはありません",
      boardDescription: "フィルター条件に一致するサブオーダーはありません。",
      boardLink: "ポートフォリオを見る",
      planTitle: "サブオーダーはありません",
      planDescription: "このプランにはまだサブオーダーがありません。",
      planLink: "生産プランナーを開く",
    },

    filters: {
      allStatuses: "すべてのステータス",
      allDesigners: "すべてのデザイナー",
      allBuyers: "すべてのバイヤー",
    },

    command: {
      noResults: "結果が見つかりません。",
      productionPlans: "生産プラン",
      quickActions: "クイックアクション",
      goToPortfolio: "ポートフォリオへ",
      goToBoard: "ボードへ",
      navigate: "ナビゲート",
      open: "開く",
      close: "閉じる",
    },

    kanban: {
      blockedAndCancelled: "ブロック済み・キャンセル済み",
      columns: {
        PENDING: "保留中",
        QUOTED: "見積済",
        ASSIGNED: "割当済",
        IN_PROGRESS: "進行中",
        QA: "品質管理",
        COMPLETED: "完了",
        BLOCKED: "ブロック済",
        CANCELLED: "キャンセル済",
      },
    },

    gantt: {
      today: "今日",
      criticalPath: "クリティカルパス",
      duration: "工期",
      days: "日",
      manufacturer: "製造業者",
      dependsOn: "依存先",
    },

    detail: {
      status: "ステータス",
      manufacturer: "製造業者",
      duration: "工期",
      dependencies: "依存関係",
    },

    hover: {
      duration: "工期",
      manufacturer: "製造業者",
    },
  },

  // ─── Buyer Milestone Tracker ──────────────────────────────────────────────
  buyerTracker: {
    title: "生産進捗",
    inProgress: "進行中",
    pending: "保留中",
    milestones: {
      orderConfirmed: "注文確認",
      designEngineering: "デザインエンジニアリング",
      sampleProduction: "サンプル生産",
      approval: "承認",
      manufacturing: "量産",
      finalFinishing: "最終仕上げ",
      qualityCheckDelivery: "品質検査・配送",
    },
  },
};
